import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
// import axios from "axios";
import {
  Table,
  Button,
  Select,
  Input,
  // Space,
  Card,
  Typography,
  Modal,
  Spin,
  message,
} from "antd";
import { SearchOutlined, LoadingOutlined } from "@ant-design/icons";
import CustomSelect from "../components/CustomSelect"; 
import CustomerEntitySelect from "../components/CustomerEntitySelect";
import ConfirmModal from "../components/ConfirmModal";
import { PlusOutlined } from "@ant-design/icons";
import {
  FiBox,
  FiCheckCircle,
  FiChevronDown,
  FiChevronRight,
  FiGrid,
  FiMinus,
  FiPlus,
  FiX,
} from "react-icons/fi";
import { formatMoney, formatMoneyLoose  } from "../utils/formatMoney";
// import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import { useAccess } from "../hooks/useAccess";
// import editIcon from "../assets/edit.svg";
// import deleteIcon from "../assets/delete.svg"
import "./PriceManagement.css";
import { getUser } from "../auth";
import { hasAccess } from "../utils/roleAccess";
import CustomTooltip from "../components/CustomTooltip";
import { useOverflowTooltip } from "../hooks/useOverflowTooltip";
import Breadcrumbs from '../components/Breadcrumbs';
import axios from "../axiosSetup";
import UploadCSVButton from "../components/UploadCSVButton";
import uploadPoIcon from "../assets/upload-po.svg";
// import { downloadCustomerDiscountCSV  } from "../utils/downloadCsv";
import ProductCodeSelect from "../components/ProductCodeSelect";
import { OverflowText } from '../components/OverflowText';
import { ListChecks } from "lucide-react";
import EntityMultiSelect from "../components/EntityMultiSelect";
import qs from "qs";

function AnalyticsCard({
  title,
  value,
  onClick,
}) {
  return (
    <div className="analytics-card" onClick={onClick}>
      <div className="analytics-card-left-block">
        <div className="analytics-card-title">
          {title || "All"}
        </div>
        <div className="analytics-card-subtitle">
          Discounted Products
        </div>
      </div>
      <div className="analytics-card-line"></div>
      <div className="analytics-card-value">
        {value}
      </div>
    </div>
  );
}

const { Title, Text } = Typography;

// 🔥 GENERIC BACKEND ERROR PARSER (SAME AS ORDER)
const extractApiErrors = (error) => {
  if (!error?.response) {
    return ["Network error. Please check your internet connection."];
  }

  let data = error.response.data;

  if (data?.error) data = data.error;
  if (data?.data) data = data.data;

  const userFriendlyMessage =
    data?.details?.userFriendlyMessage || data?.userFriendlyMessage;
  if (typeof userFriendlyMessage === "string" && userFriendlyMessage.trim()) {
    return [userFriendlyMessage.replace(/\\"/g, '"').trim()];
  }

  if (typeof data === "string") return [data];
  if (Array.isArray(data)) return data.map(String);

  if (Array.isArray(data?.details)) {
    return data.details.map(d => {
      if (typeof d === "string") return d;
      if (d?.path && d?.message) return `${d.path}: ${d.message}`;
      return d?.message || JSON.stringify(d);
    });
  }

  if (Array.isArray(data?.errors)) {
    return data.errors.map(e =>
      e?.msg || e?.message || JSON.stringify(e)
    );
  }

  if (Array.isArray(data?.message)) {
    return data.message.map(String);
  }

  if (typeof data?.message === "string") {
    return [data.message];
  }

  return ["Something went wrong. Please try again."];
};


const PriceManagement = () => {

  //User Role Access
 //User Role Access (Corrected)
const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
const downloadCSV = async () => {
  try {
    setIsDownloadingCsv(true);
    const response = await axios.get(
      "/customer-discount/download-csv",
      {
        responseType: "blob",
        params: {
          customerId: filters.customerId || undefined,
          productType: filters.productType || undefined,
          productCode: filters.productCode || undefined,
          orderByDiscount: orderByDiscount || undefined,
        },
      }
    );

    const blob = new Blob([response.data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "customer_discounts.csv";
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
     
        message.success("CSV downloaded successfully");
  } catch (err) {
    console.error(err);
    showBackendError(err);
  } finally {
    setIsDownloadingCsv(false);
  }
};


// useEffect(() => {
//   console.log({ canCreate, canRead, canUpdate, canDelete });
// }, [canCreate, canRead, canUpdate, canDelete]);

const validateDiscountLive = (value) => {
  const num = Number(value);

  if (value === "" || value === undefined) {
    setValidationErrors((prev) => ({
      ...prev,
      discount: "Discount is required.",
    }));
    return;
  }
if (Number(value) === 0) {
  setValidationErrors((prev) => ({
    ...prev,
    discount: "Discount cannot be zero.",
  }));
  return;
}

  if (num === 0) {
    setValidationErrors((prev) => ({
      ...prev,
      discount: "Discount cannot be zero.",
    }));
  } else if (num < 0) {
    setValidationErrors((prev) => ({
      ...prev,
      discount: "Discount cannot be negative.",
    }));
  } else if (
    formData.discountType === "Percentage" &&
    num > 100
  ) {
    setValidationErrors((prev) => ({
      ...prev,
      discount: "Percentage cannot exceed 100%.",
    }));
    
  } else {
    setValidationErrors((prev) => ({
      ...prev,
      discount: "",
    }));
  }
};


const [alert, setAlert] = useState({
  type: "error",
  message: "",
  navigateOnClose: false,
});

  const [activeTab, setActiveTab] = useState("overview");
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [discountData, setDiscountData] = useState([]);
  const [analytics,setAnalytics]=useState([]);
  // const [allDiscounts, setAllDiscounts] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [error, setError] = useState(null);
  const [showMappingModal, setShowMappingModal] = useState(false);
  const [mappingAnalytics, setMappingAnalytics] = useState(null);
  const [overviewAnalytics, setOverviewAnalytics] = useState(null);
const [isInitialLoading, setIsInitialLoading] = useState(true);
const [isSilentFetching, setIsSilentFetching] = useState(false);

  const [customersList, setCustomersList] = useState([]);
  const [overviewCustomersList, setOverviewCustomersList] = useState([]);
  const [overviewCustomersLoading, setOverviewCustomersLoading] = useState(true);
  const [productCategoryList, setProductCategoryList] = useState([]);
  const [mappingProductCategoryList, setMappingProductCategoryList] = useState([]);
  const [filterProductList, setFilterProductList] = useState([]);  // used in filter bar
const [modalProductList, setModalProductList] = useState([]);    // used in modal (edit/create)
const [isDiscountFocused, setIsDiscountFocused] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    customer: "",
    productType: "",
    product: "",
    validFrom: "",
    validTo: "",
    discountType: "",
    discount: "",
  });
const [mappingData, setMappingData] = useState([]);
const [mappingLoading, setMappingLoading] = useState(false);
const [mappingCustomer, setMappingCustomer] = useState(null);
const [expandedOverviewCustomerId, setExpandedOverviewCustomerId] = useState(null);
const [expandedMappingCustomerId, setExpandedMappingCustomerId] = useState(null);
const expandedMappingCustomerIdRef = useRef(null);
const [mappingDrafts, setMappingDrafts] = useState({});
const [mappingProductSearches, setMappingProductSearches] = useState({});
const [savingMappingCustomerId, setSavingMappingCustomerId] = useState(null);
const [mappingCategoryFilters, setMappingCategoryFilters] = useState({});
const [mappingExpandLoading, setMappingExpandLoading] = useState(null);
  const [auditPage, setAuditPage] = useState(1);
  const [auditPageSize, setAuditPageSize] = useState(10);
  const [auditTotalPages, setAuditTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [overviewProductPage, setOverviewProductPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [masterProductList, setMasterProductList] = useState([]);
  const fileInputRef = useRef(null);
const user = getUser();  
const isAdmin = user?.role === "admin";
  const [showConfirm, setShowConfirm] = useState(false);
const [pendingFile, setPendingFile] = useState(null);
  const [filters, setFilters] = useState({
    customerId: null,
    productType: null,
    productCode: null
  });

  const [filterUI, setFilterUI] = useState({
    customer: "",
    productType: "",
    productCategory: "",
    product: ""
  });

  const [showSaveConfirm, setShowSaveConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [dateTouched, setDateTouched] = useState(false);
  // Sorting State
const [sortField, setSortField] = useState(null);
const [sortOrder, setSortOrder] = useState("asc");
const [orderByDiscount, setOrderByDiscount] = useState(null);
const OVERVIEW_STATE_KEY = "PRICE_MANAGEMENT_OVERVIEW_STATE";
const AUDIT_STATE_KEY = "PRICE_MANAGEMENT_AUDIT_STATE";
const TAB_STATE_KEY = "PRICE_MANAGEMENT_ACTIVE_TAB";
const isRestoringRef = useRef(false);
const isFirstLoad = useRef(true);
const [stateRestored, setStateRestored] = useState(false);
const auditRestoredRef = useRef(false);
const [isPageLoading, setIsPageLoading] = useState(false);
const overviewRequestId = useRef(0);
const auditRequestId = useRef(0);
const [uploadMode, setUploadMode] = useState("map"); 
const [mappingPage, setMappingPage] = useState(1);
const [mappingPageSize] = useState(10);
const [mappingTotalPages, setMappingTotalPages] = useState(1);
const [mappingTotalCount, setMappingTotalCount] = useState(0);
const [entityFilter, setEntityFilter] = useState([]);
const [entityOptions, setEntityOptions] = useState([]);

useEffect(() => {
  expandedMappingCustomerIdRef.current = expandedMappingCustomerId;
}, [expandedMappingCustomerId]);

const stripProductCategoryCount = (value) =>
  typeof value === "string" ? value.replace(/\s*\(\d+\)\s*$/, "").trim() : value;

const getProductCategoryName = (category) => {
  if (typeof category === "string") return stripProductCategoryCount(category);

  return stripProductCategoryCount(
    category?.category ??
    category?.productCategory ??
    category?.name ??
    category?.value ??
    category?.label ??
    ""
  );
};

const getProductCategoryCount = (category) =>
  category?.discountCount ??
  category?.mappedCount ??
  category?.productCount ??
  category?.count ??
  null;

const buildProductCategoryOptions = (categories, { showCount = false } = {}) => [
  "All",
  ...(categories || [])
    .map((category) => {
      const value = getProductCategoryName(category);
      if (!value) return null;

      const count = getProductCategoryCount(category);
      return {
        value,
        label: showCount && count !== null ? `${value} (${count})` : value,
      };
    })
    .filter(Boolean),
];

const getPaginationPages = (current, total) => {
  const pages = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }

  if (current <= 3) {
    return [1, 2, 3, 4, "...", total];
  }

  if (current >= total - 2) {
    return [1, "...", total - 3, total - 2, total - 1, total];
  }

  return [1, "...", current - 1, current, current + 1, "...", total];
};

// const parseDate = (val) => (val ? new Date(val) : null);
const showBackendError = (err) => {
  const errors = extractApiErrors(err);
  const backendCode = err?.response?.data?.code;
  const finalErrors =
    Array.isArray(errors) && errors.length
      ? errors
      : ["Something went wrong. Please try again."];

  setAlert({
    type: "error",
    message: finalErrors.join("\n"),   // 🔥 multi-line
    navigateOnClose: backendCode === "UNIQUE_CONSTRAINT_ERROR",
  });
  message.error(finalErrors[0]);
};
// 🔐 PERMISSIONS — MUST COME FIRST
const getCustomerPricePermissions = () => {
  try {
    const stored = sessionStorage.getItem("APP_USER_INFO");
    if (!stored) return {};

    const user = JSON.parse(stored);

    const service = user.services?.find(
      s => s.service === "Customer Price Management"
    );

    const ops = service?.operations || [];

    return {
      canCreate: ops.includes("CREATE"),
      canUpdate: ops.includes("UPDATE"),
      canDelete: ops.includes("DELETE"),
      canRead: ops.includes("READ"),
    };
  } catch {
    return {};
  }
};

const {
  canCreate,
  canUpdate,
  // canDelete,
  canRead,
} = getCustomerPricePermissions();

const canAdd    = canCreate;
const canEdit   = canUpdate;
// const canRemove = canDelete;
const canView   = canRead;


//  Sorting logic
const handleSort = (field) => {
  if (field !== "discount") return;

  const newOrder =
    sortField === field && sortOrder === "asc" ? "desc" : "asc";

  setSortField(field);
  setSortOrder(newOrder);

  const backendOrder = newOrder.toUpperCase(); // "ASC" | "DESC"
  setOrderByDiscount(backendOrder);

  setPage(1);
};


const formatToTwoDecimalsForDisplay = (val) => {
  if (val === null || val === undefined || val === "") return "";

  const num = Number(val);
  if (Number.isNaN(num)) return "";

  // If integer → show as-is, else show max 2 decimals
  return num % 1 === 0 ? num.toString() : num.toFixed(2);
};


  const validateField = (field, value) => {
    let error = "";

    if (field === "discount") {
      const discountValue = String(value ?? "").trim();
      if (!discountValue) {
        error = "Discount is required.";
      } else if (Number(discountValue) === 0) {
        error = "Discount cannot be zero.";
      }
    } else if (!value) {
      error = `${field.replace(/([A-Z])/g, " $1")} is required`;
    }

    setValidationErrors((prev) => ({
      ...prev,
      [field]: error,
    }));
  };
  const stripMoney = (v) => String(v || "").replace(/[^\d.]/g, "");

  const validateDatePair = (from, to) => {
    const errors = { validFrom: "", validTo: "" };

    // Valid From / Valid To are optional.
    // Only check range when both dates are provided.
    if (!from || !to) {
      return errors;
    }

    const dFrom = dayjs(from);
    const dTo = dayjs(to);

    if (dFrom.isAfter(dTo)) {
      errors.validFrom = "Valid From cannot be after Valid To.";
      errors.validTo = "Valid To must be after Valid From.";
    }

    return errors;
  };
const OverflowCell = ({ text }) => {
  const { ref, showTooltip } = useOverflowTooltip(text);

  return (
    <CustomTooltip message={text} show={showTooltip} color="#4A1476">
      <span
        ref={ref}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "inline-block",
          maxWidth: "100%",
        }}
      >
        {text}
      </span>
    </CustomTooltip>
  );
};
const [dateKey, setDateKey] = useState(0);

  const defaultForm = {
    customer: "",
    customerCurrency: "",   
    productType: "All",
    product: "All",
    validFrom: "",
    validTo: "",
    discountType: "Percentage",
    discountValue: "",
    notes: "",
    minimumQuantity: 0,
  };
  const emptyValidationErrors = {
  customer: "",
  productType: "",
  product: "",
  validFrom: "",
  validTo: "",
  discountType: "",
  discount: "",
  minimumQuantity: "",
};
  const [formData, setFormData] = useState(defaultForm);

  const [auditTrail, setAuditTrail] = useState([]);

  const [auditSearch, setAuditSearch] = useState("");
  const [auditCustomerFilter, setAuditCustomerFilter] = useState(null);

// const filteredAuditTrail = auditTrail;
useEffect(() => {
  return () => {
    // 🔥 Clear persisted state when leaving this page
    sessionStorage.removeItem(TAB_STATE_KEY);
    sessionStorage.removeItem(OVERVIEW_STATE_KEY);
    sessionStorage.removeItem(AUDIT_STATE_KEY);
  };
}, []);
useEffect(() => {
  if (!stateRestored) return;       
  if (isRestoringRef.current) return;

  sessionStorage.setItem(TAB_STATE_KEY, activeTab);
}, [activeTab, stateRestored]);
const fetchCustomerProductMapping = async () => {
  setMappingLoading(true);
  try {
    const res = await axios.get(`/customer/dropdown/products`, {
      params: {
        page: mappingPage,
        limit: mappingPageSize,
        ...(filters.customerId && { customerId: filters.customerId }),
        ...((entityFilter && entityFilter.length>0) && {
          entity: entityFilter,
        }),
        ...(filters.productCode && { productCode: filters.productCode }),
      },
      paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: "repeat" }),
    });

    const nextMappings = res.data?.customerProductMappings || [];
    setMappingData((prev) => {
      const expandedId = expandedMappingCustomerIdRef.current;
      if (!expandedId) return nextMappings;

      const expandedRow = prev.find(
        (item) => String(item.customerId) === String(expandedId)
      );
      if (!expandedRow) return nextMappings;

      return nextMappings.map((item) =>
        String(item.customerId) === String(expandedId)
          ? {
              ...item,
              allProducts: expandedRow.allProducts || item.allProducts,
              mappedProducts: expandedRow.mappedProducts || item.mappedProducts,
            }
          : item
      );
    });
    setMappingAnalytics(res.data?.analytics || null);
    setMappingTotalPages(res.data?.totalPages || 1);
    setMappingTotalCount(
      res.data?.total ??
      res.data?.totalCount ??
      res.data?.totalRecords ??
      0
    );
    setMappingDrafts({});
    setMappingProductSearches({});
  } catch (err) {
    showBackendError(err);
  } finally {
    setMappingLoading(false);
  }
};

  useEffect(() => {
  if (activeTab !== "mapping") return;
  // Only refetch when the mapping-relevant filters change
  fetchCustomerProductMapping();
}, [activeTab,entityFilter, filters.customerId, filters.productCode, mappingPage]);


useEffect(() => {
  isRestoringRef.current = true;

  const restoredTab = "overview";

  setActiveTab(restoredTab);

  const savedOverview = sessionStorage.getItem(OVERVIEW_STATE_KEY);
  if (savedOverview) {
    const s = JSON.parse(savedOverview);
    const restoredFilters = s.filters ?? {};

    setFilters(restoredFilters);

    // Keep mapping/overview UI in sync with filters.
    // The mapping dropdown uses filterUI.customer as the select's `value`.
    // In filters we store `customerId`, so derive UI from that.
    setFilterUI((prev) => ({
      ...(s.filterUI ?? prev),
      customer:
        restoredFilters.customerId !== null && restoredFilters.customerId !== undefined
          ? String(restoredFilters.customerId)
          : "",
      productType: restoredFilters.productType ?? "",
      product: restoredFilters.productCode ?? "",
    }));

    setPage(s.page ?? 1);
    setPageSize(s.pageSize ?? 10);
  }

  setStateRestored(true);

  requestAnimationFrame(() => {
    isRestoringRef.current = false;
  });
}, []);

useEffect(() => {
  if (!stateRestored) return;
  if (isRestoringRef.current) return;
  if (activeTab !== "overview") return;

  sessionStorage.setItem(
    OVERVIEW_STATE_KEY,
    JSON.stringify({
      filters,
      filterUI,
      page,
      pageSize
    })
  );
}, [filters, filterUI, page, pageSize, activeTab, stateRestored]);

useEffect(() => {
  const fetchEntities = async () => {
    try {
      const { data } = await axios.get("/dropdown/entity");

      setEntityOptions([
        { label: "All Entities", value: "" },
        ...data.map((e) => ({
          label: e.entity,
          value: e.entity,
        })),
      ]);
    } catch (err) {
      console.error("Failed to load entities", err);
    }
  };

  fetchEntities();
}, []);

useEffect(() => {
  if (!stateRestored) return;
  if (isRestoringRef.current) return;
  if (activeTab !== "audit") return;

  sessionStorage.setItem(
    AUDIT_STATE_KEY,
    JSON.stringify({
      auditCustomerFilter,
      auditPage,
      auditPageSize
    })
  );
}, [auditCustomerFilter, auditPage, auditPageSize, activeTab, stateRestored]);

  // --- fetchers below ---
  useEffect(() => {
    if (!dateTouched) return;

    const errs = validateDatePair(formData.validFrom, formData.validTo);

    setValidationErrors((prev) => ({
      ...prev,
      validFrom: errs.validFrom,
      validTo: errs.validTo
    }));
  }, [formData.validFrom, formData.validTo, dateTouched]);

const fetchDiscounts = async (
  currentPage = 1,
  currentLimit = 10,
  { silent = false, customerId = filters.customerId } = {}
) => {
  const reqId = ++overviewRequestId.current;

  if (!silent) {
    setIsInitialLoading(true);   // ONLY for first load
  } else {
    setIsSilentFetching(true);  // invisible fetch
  }

  try {
    const params = {
      page: currentPage,
      limit: currentLimit,
      ...(customerId && { customerId }),
      ...(filters.productType && { productType: filters.productType }),
      ...(filters.productCategory && { productCategory: filters.productCategory }),
      ...((entityFilter && entityFilter.length>0) && { entity: entityFilter }),
      ...(filters.productCode && { productCode: filters.productCode }),
      ...(orderByDiscount && { orderByDiscount }),
    };
    setAnalytics([]);

    const res = await axios.get("/customer-discount", { 
      params,
      paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: "repeat" }),
    });

    if (reqId !== overviewRequestId.current) return;

    const nextDiscounts = res.data?.customerDiscounts || [];
    const nextTotalPages = res.data?.totalPages || 1;
    const nextTotalRecords =
      res.data?.total ??
      res.data?.totalRecords ??
      res.data?.totalCount ??
      res.data?.count ??
      nextTotalPages * currentLimit;

    setDiscountData(nextDiscounts);
    setAnalytics(() => {
      const analytics = res.data?.analytics ?? [];
      const all = analytics.find(({ title }) => title === "All");

      return [
        all,
        ...analytics.filter(({ title }) => !["All", "Other"].includes(title)),
        {
          title: "Other",
          category: null,
          discountedProductsCount:
            (all?.discountedProductsCount ?? 0) -
            analytics
              .filter(({ title }) => !["All", "Other"].includes(title))
              .reduce((sum, { discountedProductsCount }) => sum + discountedProductsCount, 0),
        },
      ].filter(Boolean);
    });
    setTotalPages(nextTotalPages);
    setTotalRecords(nextTotalRecords);
  } catch (err) {
  console.error(err);
  showBackendError(err);
} finally {
    if (!silent) {
      setIsInitialLoading(false);
    } else {
      setIsSilentFetching(false);
    }
  }
};

const didFetchRef = useRef(false);

useEffect(() => {
  if (!filters.customerId) return;
  setExpandedOverviewCustomerId(String(filters.customerId));
  setOverviewProductPage(1);
}, [filters.customerId]);

useEffect(() => {
  if (!stateRestored) return;
  if (activeTab !== "overview") return;

  if (!expandedOverviewCustomerId) {
    setDiscountData([]);
    setTotalPages(1);
    setTotalRecords(0);
    return;
  }

  if (didFetchRef.current && page === 1 && !filters) return;
  didFetchRef.current = true;

  fetchDiscounts(overviewProductPage, pageSize, {
    silent: false,
    customerId: expandedOverviewCustomerId,
  });

}, [
  stateRestored,
  activeTab,
  expandedOverviewCustomerId,
  overviewProductPage,
  pageSize,
  entityFilter,
  filters.productCategory,
  filters.productCode,
  filters.productType,
  orderByDiscount,
]);



  // const productCodesFetched = React.useRef(false);
  const fetchingRef = React.useRef(false);

  const normalizeProductDescription = (code, desc) => {
    if (!desc) return "";
    return desc.startsWith(code)
      ? desc.replace(new RegExp(`^${code}\\s*-\\s*`, "i"), "")
      : desc;
  };

  // Fetch product list only when customer changes
useEffect(() => {
  if (!formData.customer) return;

  const fetchProductsByCustomer = async () => {
    try {
      const res = await axios.get("/dropdown/product-code", {
        params: { customerId: formData.customer }
      });

      const productList = (res.data || []).map((p) => ({
        code: p.productCode,
        description: normalizeProductDescription(p.productCode, p.productDescription)
      }));

      setMasterProductList(productList);
      setModalProductList(productList);
    } catch (err) {
      console.error("Failed to fetch products by customer", err);
      showBackendError(err);
    }
  };

  fetchProductsByCustomer();
}, [formData.customer]);

useEffect(() => {
  if(activeTab!=="overview" || !expandedOverviewCustomerId ) return;
  const fetchProductCodesForFilter = async () => {
    try {
      const res = await axios.get("/customer-discount/dropdown/product-code",{
        params:{
          ...(expandedOverviewCustomerId && {customerId:expandedOverviewCustomerId})
        }
      });
      const list = (res.data || []).map((p) => ({
        code: p.productCode,
        description: p.productDescription,
      }));
      setFilterProductList(list);
    } catch (err) {
      console.error("Error fetching product codes for filter", err);
      showBackendError(err);
    }
  };
  const fetchProductCategoriesForFilter = async () => {
    try {
      const res = await axios.get("/customer-discount/dropdown/product-categories",{
        params:{
          ...(expandedOverviewCustomerId && {customerId:expandedOverviewCustomerId})
        }
      });
      setProductCategoryList(res.data || []);
    } catch (err) {
      console.error("Error fetching product codes for filter", err);
      showBackendError(err);
    }
  };
  fetchProductCodesForFilter();
  fetchProductCategoriesForFilter();
}, [expandedOverviewCustomerId,activeTab]);




const normalizeCustomerDropdownItem = (c) => ({
  id: c.id ?? c.customerId ?? c.value,
  name: c.name ?? c.customerName ?? c.label ?? "-",
  currency: c.currency,
  entity:
    c.entity ??
    c.entityName ??
    c.company ??
    c.organization ??
    c.businessName ??
    "",
  entityName:
    c.entityName ??
    c.entity ??
    c.company ??
    c.organization ??
    c.businessName ??
    "",
  customerCode: c.customerCode ?? c.code ?? "",
});

  const customersFetchedRef = useRef(false);
useEffect(() => {
  if (customersFetchedRef.current) return;
  customersFetchedRef.current = true;

  const fetchCustomers = async () => {
    try {
      const res = await axios.get("/dropdown/customers");
      const customerData = (res.data || []).map(normalizeCustomerDropdownItem);
      setCustomersList(customerData);
    } catch (err) {
      console.error("Failed to fetch customers", err);
      showBackendError(err);
    }
  };

  fetchCustomers();
}, []);

useEffect(() => {
  if (activeTab !== "overview") return;

  const fetchOverviewCustomers = async () => {
    setOverviewCustomersLoading(true);
    try {
      const res = await axios.get("/customer-discount/dropdown/customers",{
        params:{
          ...((entityFilter && entityFilter.length>0) && { entity: entityFilter }),
        },
        paramsSerializer: (params) =>
            qs.stringify(params, { arrayFormat: "repeat" }),
      });
      const customerData = (res.data.customers || []).map(normalizeCustomerDropdownItem);
      setOverviewCustomersList(customerData);
      const customerStillExists = customerData.some(
        (c) => String(c.id) === String(filters.customerId)
      );

      if (!customerStillExists && filters.customerId) {
        setFilters(prev => ({
          ...prev,
          customerId: null,
          productCategory: null,
          productCode: null,
        }));

        setFilterUI(prev => ({
          ...prev,
          customer: "All Customers",   // or "" if that's your default
          productCategory: "",
          product: "",
        }));

        setExpandedOverviewCustomerId(null);
        setOverviewProductPage(1);
      }
      setOverviewAnalytics(res.data.analytics || []);
    } catch (err) {
      console.error("Failed to fetch customer discount customers", err);
      showBackendError(err);
    } finally {
      setOverviewCustomersLoading(false);
    }
  };

  fetchOverviewCustomers();
}, [entityFilter]);


   const fetchAuditTrail = async (page = 1, pageSize = 10) => {
  const reqId = ++auditRequestId.current;
  setIsPageLoading(true);

  try {
    const res = await axios.get("/customer-discount/audit-trail", {
      params: {
        page,
        limit: pageSize,
        ...(auditCustomerFilter && { customerId: auditCustomerFilter }),
      },
    });

    if (reqId !== auditRequestId.current) return;

    const mapped = (res.data.auditTrail || []).map((item) => ({
      key: item.id,
      dateTime: dayjs(item.createdAt).format("MMM D, YYYY"),
      changedBy: item.changedBy || "Unknown",
      customer: item.customerName || "-",
      product: item.productCode,
      oldDiscount:
        item.oldDiscountType === "Fixed Price"
          ? formatMoney(item.oldDiscount,item.currency)
          : `${item.oldDiscount || 0}%`,
      newDiscount:
        item.newDiscountType === "Fixed Price"
          ? formatMoney(item.newDiscount,item.currency)
          : `${item.newDiscount || 0}%`,
      status: item.active ? "Active" : "Inactive",
      notes: item.notes || "-",
    }));

    setAuditTrail(mapped);
    setAuditTotalPages(res.data.totalPages || 1);
  } catch (err) {
    showBackendError(err);
  } finally {
    if (reqId === auditRequestId.current) {
      setIsPageLoading(false);
    }
  }
};


useEffect(() => {
  if (!stateRestored) return;
  if (activeTab !== "audit") return;

  fetchAuditTrail(auditPage, auditPageSize);
}, [
  stateRestored,
  activeTab,
  auditPage,
  auditPageSize,
  auditCustomerFilter
]);

const selectedCustomerName = useMemo(() => {
  return customersList.find(c => c.id === formData.customer)?.name;
}, [customersList, formData.customer]);


  // ---------- Handlers ----------

  const openCreateModal = () => {
    setFormData(defaultForm);
    setModalProductList(masterProductList);
    setIsEdit(false);
    setSelectedRecord(null);
    setShowModal(true);
    setDateTouched(false);
  };

  const handleAuditSearchClick = async () => {
    if (!auditSearch.trim()) {
      message.warning("Enter a name to search");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.get(
        `/customer-discount/audit-trail?customerName=${encodeURIComponent(auditSearch)}`
      );

      const data = res.data.auditTrail || [];

      const mapped = data.map((item) => ({
        key: item.id,
        dateTime: dayjs(item.createdAt).format("MMM D, YYYY"),
        changedBy: item.changedBy || "Unknown",
        customer: item.customerName || "-",
        product: item.productCode,
        oldDiscount: `${item.oldDiscount || 0}${
          item.oldDiscountType === "Fixed Price" ? "₹" : "%"
        }`,
        newDiscount: `${item.newDiscount || 0}${
          item.newDiscountType === "Fixed Price" ? "₹" : "%"
        }`,
        status: item.active ? "Active" : "Inactive",
        notes: item.notes || "-",
      }));

      setAuditTrail(mapped);
    } catch (err) {
      console.error("Search API error:", err);
      showBackendError(err);
    } finally {
      setLoading(false);
    }
  };
const handleAuditSearchEnter = async () => {
  if (!auditSearch.trim()) {
    message.warning("Enter a customer name");
    return;
  }

  // Match typed name to an ID
  const match = customersList.find(
    c => c.name.toLowerCase() === auditSearch.toLowerCase()
  );

  if (!match) {
    message.error("Customer not found");
    return;
  }
//  ONLY state updates (useEffect will call API)
  setAuditCustomerFilter(match.id);
  setAuditPage(1);
  
};

  const fetchDiscountDetailById = async (id) => {
    try {
      const res = await axios.get(`/customer-discount/${id}`);
      const detail =
        res.data?.discount && typeof res.data.discount === "object"
          ? res.data.discount
          : res.data || {};
      return detail;
    } catch (err) {
      console.error("Error fetching discount detail:", err);
      showBackendError(err);
      return null;
    }
  };

  const fetchProductTypeForEdit = async (type,customerId) => {
    try {
      const res = await axios.get(`/dropdown/product-code`, {
      params: {
        customerId: customerId,   // REQUIRED
        productType: type !== "All" ? type : undefined,
      }
    });
      const list = (res.data || []).map((p) => ({
        code: p.productCode,
        description: p.productDescription,
      }));
      setModalProductList(list);
      return list;
    } catch (err) {
      console.error("Error loading product list on edit", err);
      showBackendError(err);
      return [];
    }
  };

  const openEditModal = async (record) => {
    if (!record?.id) {
      message.error("Missing discount ID. Cannot edit this record.");
      return;
    }

    setLoading(true);
    setIsEdit(true);
    setSelectedRecord(record);
    setDateTouched(false);

    try {
      const detail = await fetchDiscountDetailById(record.id);

      if (!detail) {
        setFormData({
          customer: record.customerId || "",
          productType: record.productType || "All",
          product: record.productCode || "All",
          discountType: record.discountType || "Percentage",
          discountValue: record.discount || 0,
          validFrom: record.raw?.validFrom ? dayjs(record.raw.validFrom) : null,
          validTo: record.raw?.validTo ? dayjs(record.raw.validTo) : null,
          minimumQuantity: record.raw?.minimumQuantity || 0,
          notes: record.raw?.notes || "",
        });
        setShowModal(true);
        setLoading(false);
        return;
      }

      const resolvedCustomerId = (() => {
        if (detail.customerId) return detail.customerId;
        const match = customersList.find(
          (c) =>
            c.name?.toLowerCase() === detail.customerName?.toLowerCase()
        );
        return match?.id || "";
      })();

      const filledForm = {
        customer: resolvedCustomerId,
        customerCurrency:
    customersList.find(c => c.id === resolvedCustomerId)?.currency || "",
        productType: detail.productType || "All",
        product: detail.productCode || "All",
        minimumQuantity: detail.minimumQuantity ?? 0,
        validFrom: detail.validFrom
        ? dayjs(detail.validFrom, "DD-MM-YYYY").format("YYYY-MM-DD")
        : "",
      validTo: detail.validTo
        ? dayjs(detail.validTo, "DD-MM-YYYY").format("YYYY-MM-DD")
        : "",
        discountType: detail.discountType || "Percentage",
        discountValue: formatToTwoDecimalsForDisplay(detail.discount),
        notes: detail.notes || "",
      };

      if (filledForm.productType && filledForm.productType !== "All") {
        const list = await fetchProductTypeForEdit(
  filledForm.productType,
  filledForm.customer
);

        await new Promise((r) => setTimeout(r, 100));

        const productValid = list.some((p) => p.code === filledForm.product);
        if (!productValid) filledForm.product = "All";
      }

      setFormData(filledForm);
      setShowModal(true);
    } catch (err) {
      console.error("openEditModal failed:", err);
      showBackendError(err);
    } finally {
      setLoading(false);
    }
  };

 const handleDelete = async (id) => {
  if (!id) return;

  setLoading(true);
  try {
    await axios.delete(`/customer-discount/${id}`);
    message.success("Discount deleted successfully!");
  } catch (err) {
    showBackendError(err);
  } finally {
    setLoading(false);
  }
};
// const enrichWithDescription = (rows) =>
//   rows.map(r => {
//     const match =
//       masterProductList.find(p => p.code === r.productCode) ||
//       filterProductList.find(p => p.code === r.productCode);

//     return {
//       ...r,
//       // productDescription: match?.description || "",
//     };
//   });
// useEffect(() => {
//   if (!discountData.length) return;
//   if (!filterProductList.length && !masterProductList.length) return;

//   setDiscountData(prev => enrichWithDescription(prev));
// }, [filterProductList, masterProductList]);

useEffect(() => {
  if (activeTab !== "mapping") {
    setMappingAnalytics(null);
  }
}, [activeTab]);

  const handleSave = async () => {
    try {
      const requiredChecks = {
        customer: formData.customer,
        productType: formData.productType,
        product: formData.product,
        discountType: formData.discountType,
        discount: formData.discountValue,
      };

      let hasError = false;
      Object.entries(requiredChecks).forEach(([key, value]) => {
        if (!value) {
          validateField(key, value);
          hasError = true;
        }
      });

      if (hasError) {
        message.error("Please fill all required fields.");
        return false;
      }

      // if (!formData.discountValue || Number(formData.discountValue) <= 0) {
      //   validateField("discount", formData.discountValue);
      //   message.error("Please enter a valid discount value greater than 0.");
      //   return false;
      // }
      const discountNum = Number(formData.discountValue);

// Block ONLY pure zero (0 or "0")
if (discountNum === 0) {
  setValidationErrors((prev) => ({
    ...prev,
    discount: "Discount cannot be zero.",
  }));

  message.error("Discount cannot be zero.");
  return false;
}


      if (
        formData.discountType === "Percentage" &&
        (!formData.discountValue || discountNum <= 0)
      ) {
        validateField("discount", formData.discountValue);
        message.error("Percentage must be greater than 0.");
        return false;
      }

      if (
        formData.discountType === "Fixed Price" &&
        (formData.discountValue === "" || discountNum < 0)
      ) {
        validateField("discount", formData.discountValue);
        message.error("Fixed Price cannot be negative.");
        return false;
      }


      if (formData.discountType === "Percentage" && formData.discountValue > 100) {
        setValidationErrors((prev) => ({
          ...prev,
          discount: "Percentage cannot exceed 100%",
        }));
        message.error("Percentage discount cannot exceed 100%");
        return false;
      }

      const errs = validateDatePair(formData.validFrom, formData.validTo);

      if (errs.validFrom || errs.validTo) {
        setValidationErrors((prev) => ({
          ...prev,
          ...errs,
        }));
        message.error("Please fix the date fields before saving.");
        return false;
      }

      setLoading(true);

      const from = formData.validFrom ? dayjs(formData.validFrom) : null;
      const to = formData.validTo ? dayjs(formData.validTo) : null;
      const now = dayjs();
      const isActive =
        Boolean(from && to) &&
        now.isAfter(from) &&
        now.isBefore(to);

      const payloadBase = {
        customerId: formData.customer || null,
        customerName:
          customersList.find((c) => c.id === formData.customer)?.name || "",
        productType: formData.productType === "All" ? null : formData.productType,
        productCode: formData.product === "All" ? null : formData.product,
        discountType: formData.discountType,
        discount: Number(formData.discountValue || 0),
        notes: formData.notes || "",
        minimumQuantity: Number(formData.minimumQuantity || 0),
        validFrom: from ? from.format("YYYY-MM-DD") : null,
        validTo: to ? to.format("YYYY-MM-DD") : null,
      };

      let url = `/customer-discount`;
      let method = "post";
      let payload = { ...payloadBase };

      if (isEdit) {
        const id = selectedRecord?.id;
        if (!id) {
          message.warning("Cannot update: missing discount id from API.");
          setLoading(false);
          return false;
        }
        url = `/customer-discount/${id}`;
        method = "put";
        payload = { id, ...payloadBase, active: !!isActive };
      }

      const res = await axios[method](url, payload);
      const result = res.data || {};

      message.success(
        isEdit ? "Discount updated successfully!" : "Discount added successfully!"
      );

      const nextRow = {
        key: result.id ?? Math.random().toString(36).substr(2, 9),
        id: result.id ?? Math.random().toString(36).substr(2, 9),
        customerId: result.customerId ?? payloadBase.customerId,
        customerName:
          result.customerName ??
          payloadBase.customerName ??
          (customersList.find((c) => c.id === payloadBase.customerId)?.name || ""),
        productType: result.productType ?? payloadBase.productType,
        productCode: result.productCode ?? payloadBase.productCode,
        //  productDescription: result.productDescription || "",
        discount: result.discount ?? payloadBase.discount,
        discountType: result.discountType ?? payloadBase.discountType,
        validFrom: result.validFrom ?? payloadBase.validFrom,
        validTo: result.validTo ?? payloadBase.validTo,
        minimumQuantity: result.minimumQuantity ?? payloadBase.minimumQuantity,
        active: isEdit ? !!isActive : result.active ?? false,
        raw: { ...result },
      };

      if (isEdit) {
        // setAllDiscounts((prev) =>
        //   prev.map((it) => (it.id === nextRow.id ? nextRow : it))
        // );
        setDiscountData((prev) =>
          prev.map((it) => (it.id === nextRow.id ? nextRow : it))
        );
      } else {
        // setAllDiscounts((prev) => [...prev, nextRow]);
      }

      return true;
    } catch (err) {
      console.error(err);
      showBackendError(err);
      const backendDetails = err.response?.data?.details;
      if (Array.isArray(backendDetails)) {
        const errorMap = {};
        backendDetails.forEach((item) => {
          if (item.path && item.message) {
            errorMap[item.path] = item.message;
          }
        });
        backendDetails.forEach((item) => {
  if (item.path === "minimumQuantity") {
    setValidationErrors((prev) => ({
      ...prev,
      minimumQuantity: item.message
    }));
  }
});

        setValidationErrors((prev) => ({ ...prev, ...errorMap }));
        return false;
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
    setPage(1);
    setOverviewProductPage(1);
    setMappingPage(1);

    if (Object.prototype.hasOwnProperty.call(newFilters, "customerId")) {
      setExpandedOverviewCustomerId(
        newFilters.customerId ? String(newFilters.customerId) : null
      );
    }
  };

  // THE ONLY CHANGE YOU ASKED FOR IS HERE
  // MOVED actionColumn JUST BEFORE customerColumns

  // Highlighted Action column is commented out per current design requirement.
  // const actionColumn = (canEdit || canRemove )
  /*
  const actionColumn = (canEdit || canRemove )
    ? {
         title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Action
    </div>
  ),
        width: 50,
        render: (_, record) => (
          <Space>
            {canEdit && (
               <CustomTooltip message="Edit Discount" placement="top" color="#4A1476">
              <button
                disabled={!record.id}
                onClick={() => openEditModal(record)}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                <img src={editIcon} alt="edit" style={{ width: 28, height: 28 }} />
              </button></CustomTooltip>
            )}

            {canRemove  && (
              <CustomTooltip message="Delete Discount" placement="top" color="#4A1476">
              <button
                disabled={!record.id}
                onClick={() => {
                  setDeleteId(record.id);
                  setShowDeleteConfirm(true);
                }}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 0,
                }}
              >
                <img src={deleteIcon} alt="delete" style={{ width: 28, height: 28 }} />
              </button></CustomTooltip>
            )}
          </Space>
        ),
      }
    : null;
  */

  // END OF MOVED BLOCK 


const renderDiscountValue = (record) => {
  const value = Number(record.discount);
  const formatted = Number.isNaN(value)
    ? "-"
    : value % 1 === 0
      ? value
      : value.toFixed(2);

  return record.discountType === "Percentage"
    ? `${formatted}%`
    : `${record.currency || ""}${formatMoney(value)}`;
};

 const customerDiscountColumns = [
 {
   title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Customer Name
    </div>
  ),
  dataIndex: "customerName",
  width: 250,
  align: "left",

  render: (text) => <OverflowCell text={text} />,
},

 
 
    {
       title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Product Category
    </div>
  ),
      dataIndex: "productCategory",
      width: 150,
      align: "left",
      render: (text) => <OverflowCell text={text} />,
    },
 
    {
 title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Product Code
    </div>
  ),
  dataIndex: "productCode",
  width:200,
  render: (text, record) => (
    <CustomTooltip
      message={
        record.productDescription ||
        record.raw?.productDescription ||
        text
      }
      show={true}
      color="#4A1476"
    >
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "inline-block",
          maxWidth: "100%",
        }}
      >
        {text}
      </span>
    </CustomTooltip>
  ),
},
    {
       title: (
        <div style={{ textAlign: "center", width: "100%" }}>
          Product Description
        </div>
      ),
      dataIndex: "productDescription",
      align: "left",
      render: (text) => <OverflowText text={text} />,
    },

    {
       title: (
        <div style={{ textAlign: "center", width: "100%" }}>
          RRP
        </div>
      ),
      dataIndex: "rrp",
      align: "right",
      width: 100,
      render: (text,record) => <OverflowText text={text?formatMoney(text,record.currency):text} />,
    },
    
    {
        title: (
          <div 
            // className="sort-wrapper" 
            // onClick={() => handleSort("discount")} 
            style={{ maxWidth: 200, textAlign:"center" }}
          >
            Discount
            {/* <div className="sort-icons">
              <span className={sortField === "discount" && sortOrder === "asc" ? "active" : ""}>
                ▲
              </span>
              <span className={sortField === "discount" && sortOrder === "desc" ? "active" : ""}>
                ▼
              </span>
            </div> */}
          </div>
        ),
        dataIndex: "discount",
        width: 100,          //discount column width
        align: "right", 
        render: (_, record) => renderDiscountValue(record),


      },
      {
       title: (
        <div style={{ textAlign: "center", width: "100%" }}>
          Discounted Price
        </div>
      ),
      dataIndex: "customerPrice",
      align: "right",
      width: 100,
      render: (text,record) => <OverflowText text={text?formatMoney(text,record.currency):text} />,
    },
    {
      
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Status
    </div>
  ),

      dataIndex: "active",
      width: 100,
      render: (val) => (
        <span
          style={{
            display: "inline-block",
            alignItems: "center",         // vertical center
            justifyContent: "center", 
            padding: "4px 35px",                     
            width: "28px",               // ✅ fixed box
            height: "20px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 600,
            lineHeight: "1", 
            color: val ? "#15803D" : "#B91C1C",
            // background: val ? "#DCFCE7" : "#FEE2E2",
            // border: val ? "1px solid #15803D" : "1px solid #B91C1C",
            
            minWidth: "30px",
            textAlign: "center",
          }}
        >
           {val ? "✔" : "✖"}
        </span>
      ),
    },
    // Highlighted Last Updated By column is commented out per current design requirement.
    // {
    //    title: (
    // <div style={{ textAlign: "center", width: "100%" }}>
    //   Last Updated By
    // </div>
    // ),
    //   dataIndex: "updatedBy",
    //   width: 160,
    //   render: (_, record) => (
    //     <OverflowCell text={record.updatedBy || record.createdBy || "-"} />
    //   ),
    // },
    // ...(actionColumn ? [actionColumn] : []),
  ];
// Client-side filter by Last Updated By (updatedBy OR createdBy)
const filteredDiscountData = discountData;

const overviewCustomerRows = useMemo(() => {
  const sourceCustomers = filters.customerId
    ? overviewCustomersList.filter((customer) => String(customer.id) === String(filters.customerId))
    : overviewCustomersList;

  return sourceCustomers.map((customer) => ({
    key: String(customer.id),
    customerId: String(customer.id),
    customerName: customer.name || "-",
    customerCode: customer.customerCode || "-",
    entity:
      customer.entity ||
      customer.entityName ||
      customer.company ||
      customer.organization ||
      customer.businessName ||
      "-",
    discounts:
      String(expandedOverviewCustomerId) === String(customer.id)
        ? filteredDiscountData
        : [],
  }));
}, [overviewCustomersList, expandedOverviewCustomerId, filteredDiscountData, filters.customerId]);

const overviewProductColumns = customerDiscountColumns.filter(
  (column) => column.dataIndex !== "customerName"
);

const overviewCustomerTotalRecords = overviewCustomerRows.length;
const overviewCustomerTotalPages = Math.max(
  1,
  Math.ceil(overviewCustomerTotalRecords / pageSize)
);
const overviewCustomerStart =
  overviewCustomerTotalRecords === 0 ? 0 : (page - 1) * pageSize + 1;
const overviewCustomerEnd = Math.min(page * pageSize, overviewCustomerTotalRecords);
const paginatedOverviewCustomerRows = filters.customerId
  ? overviewCustomerRows
  : overviewCustomerRows.slice((page - 1) * pageSize, page * pageSize);

const overviewProductTotalPages = Math.max(1, totalPages || 1);
const overviewProductTotalRecords =
  Number(totalRecords) || filteredDiscountData.length || 0;
const overviewProductStart =
  overviewProductTotalRecords === 0 ? 0 : (overviewProductPage - 1) * pageSize + 1;
const overviewProductEnd = Math.min(
  overviewProductPage * pageSize,
  overviewProductTotalRecords
);
const isOverviewProductsLoading =
  Boolean(expandedOverviewCustomerId) && (isInitialLoading || isSilentFetching);
const mappingPaginationTotalPages = Math.max(
  1,
  mappingTotalPages || Math.ceil(mappingTotalCount / mappingPageSize) || 1
);
const mappingPaginationStart =
  mappingTotalCount === 0 ? 0 : (mappingPage - 1) * mappingPageSize + 1;
const mappingPaginationEnd = Math.min(
  mappingPage * mappingPageSize,
  mappingTotalCount
);

const renderPaginationControls = ({
  current,
  totalPages: pageCount,
  totalRecords: recordCount,
  start,
  end,
  onPageChange,
}) => (
  <div className="pagination-wrapper pm-user-pagination">
    <div className="pg-info">{start} - {end} of {recordCount}</div>
    <div className="pg-buttons">
      <button
        className="pg-arrow"
        disabled={current === 1}
        onClick={() => onPageChange(current - 1)}
      >
        &lsaquo;
      </button>

      {getPaginationPages(current, pageCount).map((p, i) =>
        p === "..." ? (
          <button
            key={`dots-${i}`}
            className="pg-dots"
            onClick={() => {
              const nextPage = i === 1 ? current - 2 : current + 2;
              onPageChange(Math.min(pageCount, Math.max(1, nextPage)));
            }}
          >
            &hellip;
          </button>
        ) : (
          <button
            key={p}
            className={`pg-number ${current === p ? "active" : ""}`}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        )
      )}

      <button
        className="pg-arrow"
        disabled={current === pageCount}
        onClick={() => onPageChange(current + 1)}
      >
        &rsaquo;
      </button>
    </div>
  </div>
);

const getPriceTableRowClassName = (_, index) =>
  index % 2 === 0 ? "pm-table-row-even" : "pm-table-row-odd";

const getPriceTableLoading = (spinning) => ({
  spinning,
  indicator: (
    <Spin
      indicator={
        <LoadingOutlined style={{ fontSize: 34, color: "#f50087" }} spin />
      }
    />
  ),
  tip: <span style={{ color: "#f50087", fontWeight: 600 }}>Loading</span>,
});




const renderOverviewDiscounts = (record) => (
  <div className="mapping-expanded-wrap overview-expanded-wrap">
    <div className="mapping-expanded-card overview-expanded-card">
      <div className="mapping-expanded-header overview-expanded-header">
        <div className="left-block">
        <div className="discount-anlytics">
          {
            analytics.map((item,index)=>(
              <AnalyticsCard 
                key={index}
                title={item.title}
                value={item.discountedProductsCount}
                onClick={(e)=>{
                  e.preventDefault();
                  e.stopPropagation();
                  if(item.category){
                    if(filterUI.productCategory!==item.category){
                      setFilterUI(prev => ({ ...prev, productCategory: item.category }));
                      handleFilter({ productCategory: item.category });
                    }
                  }else{
                    if(filterUI.productCategory!=="All Categories" || filterUI.productCategory!==""){
                      setFilterUI(prev => ({ ...prev, productCategory: "All Categories" }));
                      handleFilter({ productCategory: null });
                    }
                  }
                }}
              />
            ))
          }
        </div>
        <div className="cdm-overview-filters" style={{ display: "flex", gap: "10px", marginBottom: 16 }}>
          <div style={{minWidth: 0 }}>
    <CustomSelect
    width="300px"
  value={filterUI.productCategory}
  onChange={(v) => {
    if (v === "All") {
      setFilterUI(prev => ({ ...prev, productCategory: "All Categories" }));
      handleFilter({ productCategory: null });
      return;
    }
    setFilterUI(prev => ({ ...prev, productCategory: v }));
    handleFilter({ productCategory: stripProductCategoryCount(v) });
  }}
  options={productCategoryList.length===0?[]:buildProductCategoryOptions(productCategoryList, { showCount: true })}
  placeholder="Select Product Category"
/>
  </div>

  {/* Product filter */}
  {/* <div style={{ minWidth: 0 }}>
    <CustomSelect
    width="300px"
  value={filterUI.product }
  onChange={(v) => {
    if (v === "All") {
      setFilterUI(prev => ({ ...prev, product: "All Products" }));
      handleFilter({ productCode: null });
      return;
    }
    setFilterUI(prev => ({ ...prev, product: v }));
    handleFilter({ productCode: v });
  }}
  options={["All", ...filterProductList.map(p => p.code)]}
  placeholder="Select Product Code"
/>
  </div> */}
  <div style={{ minWidth: 0 }}>
    <ProductCodeSelect
      value={filterUI.product}
      placeholder="Select Product"
      innerPlaceholder="Search by code or description "
      width="300px"
      noDataText="No Products available"
      onChange={(v) => {
        if (v === "All") {
          setFilterUI(prev => ({ ...prev, product: "All Products" }));
          handleFilter({ productCode: null });
          return;
        }
        setFilterUI(prev => ({ ...prev, product: v }));
        handleFilter({ productCode: v });
      }}
      options={[{code:"All"},...filterProductList].map((p) => {
        const code = String(p.code || "").trim();
        return {
          value: code,
          productCode: code,
          productDescription: p.description || "-",
          searchText: `${code} ${p.productDescription || p.description || ""}`,
          ...(code=="All" && {
            ignoreDescription:true,
            ignoreSearch:true,
          })
        };
      })}
    />
  </div>
        </div>
        </div>
        <button
          type="button"
          className="mapping-close-btn"
          onClick={(event) => {
            event.stopPropagation();
            setExpandedOverviewCustomerId(null);
            setDiscountData([]);
            setTotalPages(1);
            setTotalRecords(0);
            setIsInitialLoading(false);
            setIsSilentFetching(false);
          }}
          aria-label="Close product discounts"
        >
          <FiX />
        </button>
      </div>

      <Table
        className="price-overview-table overview-product-table"
        columns={overviewProductColumns}
        dataSource={record.discounts}
        rowKey={(discount) =>
          discount.id || discount.key || `${record.customerId}-${discount.productCode}`
        }
        loading={getPriceTableLoading(isOverviewProductsLoading)}
        locale={{ emptyText: isOverviewProductsLoading ? " " : "No product discounts found." }}
        pagination={false}
      />
      {overviewProductTotalRecords > 0 &&
        renderPaginationControls({
          current: overviewProductPage,
          totalPages: overviewProductTotalPages,
          totalRecords: overviewProductTotalRecords,
          start: overviewProductStart,
          end: overviewProductEnd,
          onPageChange: setOverviewProductPage,
        })}
    </div>
  </div>
);

const overviewCustomerColumns = [
  {
    title: (
      <div style={{ textAlign: "center", width: "100%" }}>
        Customer Name
      </div>
    ),
    dataIndex: "customerName",
    width: 320,
    align: "left",
    render: (text, record) => {
      const isExpanded = String(expandedOverviewCustomerId) === String(record.customerId);

      return (
        <div className="mapping-customer-cell">
          <button
            type="button"
            className={`mapping-expand-btn ${isExpanded ? "active" : ""}`}
            onClick={(event) => {
              event.stopPropagation();
              const nextCustomerId = isExpanded ? null : String(record.customerId);
              setOverviewProductPage(1);
              setDiscountData([]);
              setTotalPages(1);
              setTotalRecords(0);
              setIsInitialLoading(Boolean(nextCustomerId));
              setIsSilentFetching(false);
              setExpandedOverviewCustomerId(nextCustomerId);
            }}
            aria-label={isExpanded ? "Close product discounts" : "Open product discounts"}
          >
            {isExpanded ? <FiChevronDown /> : <FiChevronRight />}
          </button>
          <OverflowCell text={text} />
        </div>
      );
    },
  },
  {
    title: (
      <div style={{ textAlign: "center", width: "100%" }}>
        Customer Code
      </div>
    ),
    dataIndex: "customerCode",
    width: 180,
    render: (text) => <OverflowCell text={text} />,
  },
  {
    title: (
      <div style={{ textAlign: "center", width: "100%" }}>
        Entity
      </div>
    ),
    dataIndex: "entity",
    width: 300,
    render: (text) => <OverflowCell text={text} />,
  },
  {
    title: (
      <div style={{ textAlign: "center", width: "100%" }}>
        Products
      </div>
    ),
    dataIndex: "discounts",
    width: 140,
    align: "right",
    render: (discounts, record) =>
      String(expandedOverviewCustomerId) === String(record.customerId)
        ? discounts?.length || 0
        : "-",
  },
];

const overviewVisibleCustomerColumns = overviewCustomerColumns.filter(
  (column) => column.dataIndex !== "discounts"
);

// const paginatedDiscountData = filteredDiscountData.slice(
//   (page - 1) * pageSize,
//   page * pageSize
// );

const handleProductTypeChange = async (value) => {
  if (fetchingRef.current) return;
  fetchingRef.current = true;

  setFormData((prev) => ({
    ...prev,
    productType: value,
    product: "All",
  }));

  validateField("productType", value);

  const customerId = formData.customer;  // ⬅ NECESSARY

  if (!customerId) {
    message.error("Please select a customer first.");
    fetchingRef.current = false;
    return;
  }

  try {
    const res = await axios.get(
      `/dropdown/product-code`,
      {
        params: {
          customerId: customerId,
          productType: value !== "All" ? value : undefined
        }
      }
    );

    const filteredProducts = (res.data || []).map((p) => ({
      code: p.productCode,
      description: normalizeProductDescription(p.productCode, p.productDescription),
    }));

    setModalProductList(filteredProducts);
  }catch (err) {
  console.error(err);
  showBackendError(err);
}finally {
    fetchingRef.current = false;
  }
};

const getMappingProductCode = (product) =>
  product?.productCode || product?.code || "";

const getMappingProductDescription = (product) =>
  product?.productDescription || product?.description || "";

const normalizeMappingProduct = useCallback((product) => ({
  ...product,
  code: getMappingProductCode(product),
  description: getMappingProductDescription(product),
  isMapped: Boolean(product?.isMapped),
}), []);

const mappingCustomerRows = useMemo(() => {
  return (mappingData || []).map((item) => {
    const mappedProducts = Array.isArray(item.mappedProducts)
      ? item.mappedProducts.map(normalizeMappingProduct)
      : item.productCode
        ? [normalizeMappingProduct(item)]
        : [];

    const allProducts = Array.isArray(item.allProducts)
      ? item.allProducts.map(normalizeMappingProduct)
      : mappedProducts.map((product) => ({ ...product, isMapped: true }));

    return {
      ...item,
      customerId: String(item.customerId ?? item.id ?? item.customerName),
      customerName: item.customerName || item.name || "-",
      customerCode: item.customerCode || "-",
      entity: item.entity || item.entityName || "-",
      allProducts,
      mappedProducts,
    };
  });
}, [mappingData, normalizeMappingProduct]);

const getMappingDraft = (customerId) =>
  mappingDrafts[customerId] || { mapProductCodes: [], unmapProductCodes: [] };

const updateMappingDraft = (customerId, updater) => {
  setMappingDrafts((prev) => {
    const current = prev[customerId] || { mapProductCodes: [], unmapProductCodes: [] };
    const next = updater(current);

    if (!next.mapProductCodes.length && !next.unmapProductCodes.length) {
      const { [customerId]: _removed, ...rest } = prev;
      return rest;
    }

    return {
      ...prev,
      [customerId]: next,
    };
  });
};

const handleStageMapProduct = (record, product) => {
  const code = getMappingProductCode(product);
  if (!code) return;

  const originalMappedCodes = new Set(
    (record.mappedProducts || []).map((item) => getMappingProductCode(item))
  );

  updateMappingDraft(record.customerId, (draft) => {
    const mapSet = new Set(draft.mapProductCodes);
    const unmapSet = new Set(draft.unmapProductCodes);

    unmapSet.delete(code);
    if (!originalMappedCodes.has(code)) {
      mapSet.add(code);
    }

    return {
      mapProductCodes: Array.from(mapSet),
      unmapProductCodes: Array.from(unmapSet),
    };
  });
};

const handleStageUnmapProduct = (record, product) => {
  const code = getMappingProductCode(product);
  if (!code) return;

  const originalMappedCodes = new Set(
    (record.mappedProducts || []).map((item) => getMappingProductCode(item))
  );

  updateMappingDraft(record.customerId, (draft) => {
    const mapSet = new Set(draft.mapProductCodes);
    const unmapSet = new Set(draft.unmapProductCodes);

    mapSet.delete(code);
    if (originalMappedCodes.has(code)) {
      unmapSet.add(code);
    }

    return {
      mapProductCodes: Array.from(mapSet),
      unmapProductCodes: Array.from(unmapSet),
    };
  });
};

const clearMappingDraft = (customerId) => {
  setMappingDrafts((prev) => {
    const { [customerId]: _removed, ...rest } = prev;
    return rest;
  });
};

const getMappingSearch = (customerId, panel) =>
  mappingProductSearches[customerId]?.[panel] || "";

const setMappingSearch = (customerId, panel, value) => {
  setMappingProductSearches((prev) => ({
    ...prev,
    [customerId]: {
      ...(prev[customerId] || {}),
      [panel]: value,
    },
  }));
};

const fetchMappingProductCategoriesForCustomer = useCallback(async (customerId) => {
  try {
    const res = await axios.get("/customer/dropdown/product-categories", {
      params: {
        ...(customerId && { customerId }),
      },
    });
    setMappingProductCategoryList(res.data || []);
  } catch (err) {
    console.error("Error fetching mapping product categories", err);
    showBackendError(err);
  }
}, []);

const fetchMappingProductsForCustomer = useCallback(async (record, categoryOverride) => {
  const customerId = String(record.customerId);
  const selectedCategory =
    categoryOverride !== undefined
      ? categoryOverride
      : mappingCategoryFilters[record.customerId];

  setMappingExpandLoading(customerId);

  try {
    const res = await axios.get("/customer/dropdown/products", {
      params: {
        customerId: record.customerId,
        ...(selectedCategory && {
          productCategory: stripProductCategoryCount(selectedCategory),
        }),
      },
    });

    const nextMapping = res.data?.customerProductMappings?.[0];
    if (!nextMapping) return;

    setMappingData((prev) =>
      prev.map((item) =>
        String(item.customerId) === customerId
          ? { ...item, ...nextMapping }
          : item
      )
    );
  } catch (err) {
    showBackendError(err);
  } finally {
    setMappingExpandLoading(null);
  }
}, [mappingCategoryFilters]);

const productMatchesSearch = (product, search) => {
  const query = search.trim().toLowerCase();
  if (!query) return true;

  return `${getMappingProductCode(product)} ${getMappingProductDescription(product)}`
    .toLowerCase()
    .includes(query);
};

const saveMappingChanges = async (record) => {
  const draft = getMappingDraft(record.customerId);
  const hasChanges = draft.mapProductCodes.length || draft.unmapProductCodes.length;
  if (!hasChanges) return;

  try {
    setSavingMappingCustomerId(record.customerId);
    await axios.patch("/customer/product-mapping", {
      customerId: record.customerId,
      mapProductCodes: draft.mapProductCodes,
      unmapProductCodes: draft.unmapProductCodes,
    });

    message.success("Product mapping saved successfully");
    clearMappingDraft(record.customerId);
    await fetchCustomerProductMapping();
  } catch (err) {
    showBackendError(err);
  } finally {
    setSavingMappingCustomerId(null);
  }
};


const renderMappingDesigner = (record) => {
  const isLoadingProducts = mappingExpandLoading === String(record.customerId);
  const draft = getMappingDraft(record.customerId);
  const allSearch = getMappingSearch(record.customerId, "all");
  const mappedSearch = getMappingSearch(record.customerId, "mapped");
  const mapSet = new Set(draft.mapProductCodes);
  const unmapSet = new Set(draft.unmapProductCodes);
  const originalMappedCodes = new Set(
    (record.mappedProducts || []).map((product) => getMappingProductCode(product))
  );
  const allProducts = record.allProducts || [];
  const productByCode = new Map();

  [...allProducts, ...(record.mappedProducts || [])].forEach((product) => {
    const code = getMappingProductCode(product);
    if (code) productByCode.set(code, normalizeMappingProduct(product));
  });

  const mappedProducts = Array.from(productByCode.values()).filter((product) => {
    const code = getMappingProductCode(product);
    return (originalMappedCodes.has(code) && !unmapSet.has(code)) || mapSet.has(code);
  });
  const filteredAllProducts = allProducts.filter((product) =>
    productMatchesSearch(product, allSearch)
  );
  const filteredMappedProducts = mappedProducts.filter((product) =>
    productMatchesSearch(product, mappedSearch)
  );
  const hasChanges = draft.mapProductCodes.length || draft.unmapProductCodes.length;

  return (
    <div className="mapping-expanded-wrap">
      <div className="mapping-expanded-card">
        <div className="mapping-expanded-header">
          <div className="mapping-expanded-actions">
            <CustomSelect
              width="250px"
              value={mappingCategoryFilters[record.customerId] || "Select Product Category"}
              placeholder="Select Product Category"
              options={buildProductCategoryOptions(mappingProductCategoryList, { showCount: true })}
              onChange={async (value) => {
                const categoryValue =
                  value === "All" ? "" : stripProductCategoryCount(value);

                setMappingCategoryFilters((prev) => ({
                  ...prev,
                  [record.customerId]: categoryValue,
                }));

                await fetchMappingProductsForCustomer(record, categoryValue);
              }}
            />
          </div>
          <div className="mapping-expanded-actions">
            <Button
              className="mapping-save-btn"
              disabled={!hasChanges}
              loading={savingMappingCustomerId === record.customerId}
              onClick={(event) => {
                event.stopPropagation();
                saveMappingChanges(record);
              }}
            >
              Save changes
            </Button>
            <button
              type="button"
              className="mapping-close-btn"
              onClick={(event) => {
                event.stopPropagation();
                clearMappingDraft(record.customerId);
                setMappingSearch(record.customerId, "all", "");
                setMappingSearch(record.customerId, "mapped", "");
                setMappingCategoryFilters((prev) => {
                  const next = { ...prev };
                  delete next[record.customerId];
                  return next;
                });
                setExpandedMappingCustomerId(null);
              }}
              aria-label="Close product mapping"
            >
              <FiX />
            </button>
          </div>
        </div>

        {isLoadingProducts ? (
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "48px 0",
            gap: 10,
          }}>
            <Spin
              indicator={
                <LoadingOutlined style={{ fontSize: 34, color: "#f50087" }} spin />
              }
            />
            <span style={{ color: "#f50087", fontWeight: 600 }}>Loading</span>
          </div>
        ) : (

          <div className="mapping-product-panels">
            <div className="mapping-product-panel">
              <div className="mapping-panel-title">
                <span><FiBox /> All products ({allProducts.length})</span>
                <small>Click + to map</small>
              </div>
              <div className="mapping-panel-search">
                <Input
                  allowClear
                  value={allSearch}
                  placeholder="Search code or description"
                  onClick={(event) => event.stopPropagation()}
                  onChange={(event) => setMappingSearch(record.customerId, "all", event.target.value)}
                />
              </div>
              <div className="mapping-product-list">
                {filteredAllProducts.map((product) => {
                  const code = getMappingProductCode(product);
                  const description = getMappingProductDescription(product) || "-";
                  const isMapped =
                    (Boolean(product.isMapped) || originalMappedCodes.has(code) || mapSet.has(code)) &&
                    !unmapSet.has(code);
                  return (
                    <div className={`mapping-product-row ${isMapped ? "disabled" : ""}`} key={`all-${code}`}>
                      <div className="mapping-product-copy">
                        <CustomTooltip message={`${code}\n${description}`} show color="#4A1476">
                          <strong title={code}>{code}</strong>
                        </CustomTooltip>
                        <CustomTooltip message={description} show color="#4A1476">
                          <span title={description}>{description}</span>
                        </CustomTooltip>
                      </div>
                      {isMapped ? (
                        <em>Already mapped</em>
                      ) : (
                        <button
                          type="button"
                          className="mapping-product-action add"
                          aria-label={`Map ${code}`}
                          onClick={(event) => {
                            event.stopPropagation();
                            handleStageMapProduct(record, product);
                          }}
                        >
                          <FiPlus />
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="mapping-product-panel mapped">
              <div className="mapping-panel-title">
                <span><FiCheckCircle /> Mapped to customer ({mappedProducts.length})</span>
                <small>Click - to unmap</small>
              </div>
              <div className="mapping-panel-search">
                <Input
                  allowClear
                  value={mappedSearch}
                  placeholder="Search code or description"
                  onClick={(event) => event.stopPropagation()}
                  onChange={(event) => setMappingSearch(record.customerId, "mapped", event.target.value)}
                />
              </div>
              <div className="mapping-product-list">
                {filteredMappedProducts.map((product) => {
                  const code = getMappingProductCode(product);
                  const description = getMappingProductDescription(product) || "-";
                  return (
                    <div className="mapping-product-row" key={`mapped-${code}`}>
                      <div className="mapping-product-copy">
                        <CustomTooltip message={`${code}\n${description}`} show color="#4A1476">
                          <strong title={code}>{code}</strong>
                        </CustomTooltip>
                        <CustomTooltip message={description} show color="#4A1476">
                          <span title={description}>{description}</span>
                        </CustomTooltip>
                      </div>
                      <button
                        type="button"
                        className="mapping-product-action remove"
                        aria-label={`Unmap ${code}`}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleStageUnmapProduct(record, product);
                        }}
                      >
                        <FiMinus />
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        <div className="mapping-expanded-footer">
          Changes are staged - nothing saves until the user clicks "Save changes". Prevents accidental unmapping.
        </div>
      </div>
    </div>
  );
};

const mappingColumns = [
  {
    title: (
      <div style={{ textAlign: "center", width: "100%" }}>
        Customer Name
      </div>
    ),
    dataIndex: "customerName",
    width: 320,
    align: "left",
    render: (text, record) => {
      const isExpanded = String(expandedMappingCustomerId) === String(record.customerId);

      return (
        <div className="mapping-customer-cell">
          <button
            type="button"
            className={`mapping-expand-btn ${isExpanded ? "active" : ""}`}
            onClick={async (event) => {
              event.stopPropagation();

              if (isExpanded) {
                setExpandedMappingCustomerId(null);
                return;
              }
              setExpandedMappingCustomerId(String(record.customerId));
              await fetchMappingProductCategoriesForCustomer(record.customerId);
              await fetchMappingProductsForCustomer(record);
            }}
            aria-label={isExpanded ? "Close product mapping" : "Open product mapping"}
          >
            {isExpanded ? <FiChevronDown /> : <FiChevronRight />}
          </button>
          <OverflowCell text={text} />
        </div>
      );
    },
  },
  {
    title: (
      <div style={{ textAlign: "center", width: "100%" }}>
        Customer Code
      </div>
    ),
    dataIndex: "customerCode",
    width: 180,
    render: (text) => <OverflowCell text={text} />,  // 🔥
  },
  {
    title: (
      <div style={{ textAlign: "center", width: "100%" }}>
        Entity
      </div>
    ),
    dataIndex: "entity",
    width: 300,
    render: (text) => <OverflowCell text={text} />,  // 🔥
  },
];
  const auditColumns = [
    { 
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Date & Time
    </div>
  ),
 dataIndex: "dateTime", width: 180 , align:"left",render: (text) => <OverflowCell text={text} />},
    {
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Changed By
    </div>
  ),
 dataIndex: "changedBy", width: 160, render: (text) => <OverflowCell text={text} /> },
    { 
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Customer Name
    </div>
  ),
 dataIndex: "customer", width: 180,align:"left", render: (text) => <OverflowCell text={text} /> },
    { 
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Product Name
    </div>
  ),
 dataIndex: "product", width: 160, align:"left",render: (text) => <OverflowCell text={text} /> },
    { 
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Old Discount
    </div>
  ),
 dataIndex: "oldDiscount", width: 130,align:"right", render: (text) => <OverflowCell text={text} /> },
    { 
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      New Discount
    </div>
  ),
 dataIndex: "newDiscount", width: 130, align:"right",render: (text) => <OverflowCell text={text} /> },
    { 
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Status
    </div>
  ),
 dataIndex: "status", width: 120,align:"left", render: (text) => <OverflowCell text={text} /> },
    {
  title: (
    <div style={{ textAlign: "center", width: "100%" }}>
      Notes
    </div>
  ),
 dataIndex: "notes", width: 200, align:"left",render: (text) => <OverflowCell text={text} /> },
  ];

  const isFormValid = () => {
    return (
      formData.customer &&
      formData.productType &&
      formData.product &&
      formData.discountType &&
      // Number(formData.discountValue) > 0 &&
      formData.discountValue !== "" &&
      !validationErrors.customer &&
      !validationErrors.productType &&
      !validationErrors.product &&
      !validationErrors.discountType &&
      !validationErrors.discount &&
      !validationErrors.validFrom &&
      !validationErrors.validTo
    );
  };


  // ---------- UI BELOW (unchanged) ----------

// useEffect(() => {
//   if (!stateRestored) return;
//   if (activeTab !== "audit") return;
//   if (isRestoringRef.current) return; // ⬅ CRITICAL

//   const auditState = {
//     activeTab,
//     auditCustomerFilter,
//     auditPage,
//     auditPageSize
//   };

//   sessionStorage.setItem(
//     AUDIT_STATE_KEY,
//     JSON.stringify(auditState)
//   );
// }, [
//   stateRestored,
//   activeTab,
//   auditCustomerFilter,
//   auditPage,
//   auditPageSize
// ]);

const resetMappingModal = () => {
  setPendingFile(null);
  setUploadMode("map");

  if (fileInputRef.current) {
    fileInputRef.current.value = "";
  }
};

  // ---------- UI ----------

  return (
    
<div className="page-container">
  <div className="page-header">
 <Breadcrumbs /> 
 </div>
      {/* <div style={{
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom:"0.5em"
}}>
  <div/>
  <div
  style={{
    textAlign: "left",     // <-- makes sure content aligns left
    display: "flex",
    flexDirection: "column",
   marginLeft: "-32em",
  }}
>
  
  <Title
    level={3}
    style={{
      margin: 0,
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "24px",
      lineHeight: "100%",
      letterSpacing: "0",
      color: "#0B0311",
    }}
  >
    Customer Price Management
  </Title>

  <Text
    style={{
      fontFamily: "Poppins",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "100%",
      letterSpacing: "0",
      color: "#787878",
      marginTop: "10px",
      display: "block",
    }}
  >
    Define and manage your pricing
  </Text>
</div>
</div> */}


      <div className="price-management-tabs" role="tablist" aria-label="Customer price management views">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "overview"}
          className={`price-management-tab ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => {
            setExpandedOverviewCustomerId(null);
            setExpandedMappingCustomerId(null);
            setActiveTab("overview");
            setMappingAnalytics(null);
          }}
        >
          <ListChecks className="price-management-tab-icon" aria-hidden="true" strokeWidth={3} />
          Customer Pricing Overview
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === "mapping"}
          className={`price-management-tab ${activeTab === "mapping" ? "active" : ""}`}
          onClick={() => {
            setExpandedOverviewCustomerId(null);
            setExpandedMappingCustomerId(null);
            setActiveTab("mapping");
          }}
        >
          <FiGrid className="price-management-tab-icon" aria-hidden="true" />
          Customer Product Mapping
        </button>
      </div>

      <Card className="price-management-tab-panel" style={{ borderRadius: 12 }}>
        <div
          className="price-management-empty-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 24,
          }}
        >
          <div>
            {/* <Title level={5} style={{ marginBottom: 4,
              fontsize:"16px",
              fontWeight:"600",
              llineHeight: "100%",
              letterSpacing: "0%",
              color:"#7509B8"

             }}>
              {activeTab === "overview"
  ? "Customer Discounts"
  : activeTab === "audit"
  ? "Audit Trail"
  : "Customer Product Mapping"}
            </Title>
            <Text type="secondary" style={{ marginBottom: 4,
              fontsize:"14px",
              // fontWeight:"400",
              llineHeight: "100%",
              letterSpacing: "0",
              color:"#7509B8"

             }}>
              {activeTab === "overview"
                ? "Manage customer-specific pricing and discount structures"
                : "Track all changes made to customer discounts"}
            </Text> */}
          </div>

{/* <div className="header-actions">
  <Spin spinning={isDownloadingCsv} fullscreen /> */}
  
  {/*
  {activeTab === "overview" && (
    <>
  <Button
    type="default"
    onClick={downloadCSV}
    className="price-add-btn"
    loading={isDownloadingCsv}
    disabled={isDownloadingCsv}
    //className="download-csv-btn"
  >
    Download CSV File
  </Button>
<UploadCSVButton
  onSuccess={() => {
    setPage(1);
    fetchDiscounts(1, pageSize);
  }}
      />
    </>
  )}

  {activeTab === "overview" && canCreate && (
    <Button
      type="primary"
      icon={<PlusOutlined />}
      className="price-add-btn"
      onClick={openCreateModal}
    >
      Add Customer Discount
    </Button>
  )}
  */}
{/* </div> */}
</div>

        {activeTab === "overview" && (<>
          {overviewAnalytics && (
              <div  className="overview-analytics" style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
                {overviewAnalytics.map((e,i) => (
                  <div key={i} className="mapping-ac" onClick={(event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                    if (
                      e.entity &&
                      (!entityFilter ||
                        entityFilter.length !== 1 ||
                        entityFilter[0] !== e.entity)
                    ) {
                      setEntityFilter([e.entity]);
                    } else {
                      if (!e.entity && entityFilter && entityFilter.length > 0) {
                        setEntityFilter([]);
                      }
                    }
                  }}>
                    <span className="mapping-ac-value">{e.count}</span>
                    <span className="mapping-ac-label">{e.entity || "Total"}</span>
                    <span className="mapping-ac-sub">Discounted customers</span>
                  </div>
                ))}
              </div>
            )}
          
          <div className="cdm-overview-filters" style={{ display: "flex", gap: "10px", marginBottom: 16 }}>
            <div style={{ width:"300px",minWidth: 0 }}>
              <EntityMultiSelect
                options={entityOptions.map(e=>e.value).filter(Boolean)}
                selected={entityFilter}
                onChange={(updatedSelected) => {
                  setEntityFilter(updatedSelected);
                }}
              />
            </div>
  {/* Customer filter */}
  <div style={{  width:"300px",minWidth: 0 }}>
    <CustomerEntitySelect
  value={filterUI.customer}
  onChange={(value) => {
    if (!value) {
      setFilterUI(prev => ({ ...prev, customer: "" }));
      handleFilter({ customerId: null });
      return;
    }
    const customerId = Number(value);
    setFilterUI(prev => ({ ...prev, customer: String(customerId || "") }));
    handleFilter({ customerId: customerId || null });
  }}
  options={[
    {
      value: "",
      customerName: "All Customers",
      entityName: "-",
      searchText: "all customer",
    },
    ...overviewCustomersList.map(c => ({
      value: String(c.id),
      customerName: c.name || "-",
      entityName: c.entityName || c.entity || c.company || c.organization || c.businessName || "-",
      customerCode: c.customerCode || "-",
      searchText: `${c.name || ""} ${
        c.entityName || c.entity || c.company || c.organization || c.businessName || ""
      } ${c.customerCode||""}`,
    })),
  ]}
  placeholder="Select Customer"
/>
  </div>
</div>

        </>)}

       {activeTab === "overview" ? (
          <div className="price-table-wrapper1">
            
          <Table
          loading={getPriceTableLoading(overviewCustomersLoading)}
  className="price-overview-table"
  columns={overviewVisibleCustomerColumns}
  dataSource={paginatedOverviewCustomerRows}
  locale={{ emptyText: overviewCustomersLoading ? " " : "No data" }}
  rowKey={(record) => record.customerId}
  rowClassName={getPriceTableRowClassName}
  expandable={{
    expandedRowRender: renderOverviewDiscounts,
    expandedRowKeys: expandedOverviewCustomerId ? [expandedOverviewCustomerId] : [],
    showExpandColumn: false,
    rowExpandable: () => true,
  }}
  onRow={(record) => ({
    onClick: () => {
      setExpandedOverviewCustomerId((current) => {
        const nextCustomerId =
          String(current) === String(record.customerId) ? null : String(record.customerId);
        setOverviewProductPage(1);
        setDiscountData([]);
        setTotalPages(1);
        setTotalRecords(0);
        setIsInitialLoading(Boolean(nextCustomerId));
        setIsSilentFetching(false);
        return nextCustomerId;
      });
    },
  })}
  pagination={false}
/>
{!filters.customerId &&
  overviewCustomerTotalRecords > 0 &&
  renderPaginationControls({
    current: page,
    totalPages: overviewCustomerTotalPages,
    totalRecords: overviewCustomerTotalRecords,
    start: overviewCustomerStart,
    end: overviewCustomerEnd,
    onPageChange: setPage,
  })}
</div>

        ) : activeTab === "audit" ? (
          
  <>
  <div className="audit-filter" style={{ marginBottom: "25px",marginTop:"-70px", marginLeft:"23em" }}>
   {activeTab !== "overview" && (
  <CustomerEntitySelect
    width="20em"
    value={auditCustomerFilter !== null ? String(auditCustomerFilter) : ""}
    placeholder="Filter by Customer"
    onChange={(value) => {
      const next = String(value || "");
      setAuditCustomerFilter(next ? Number(next) : null);
      setAuditPage(1);
    }}
    options={[
      {
        value: "",
        customerName: "All Customers",
        entityName: "-",
        searchText: "all customer",
      },
      ...customersList.map((c) => ({
        value: String(c.id),
        customerName: c.name || "-",
        entityName: c.entity || c.entityName || "-",
        customerCode: c.customerCode || "-",
        searchText: `${c.name || ""} ${c.entity || c.entityName || ""} ${c.customerCode||""}`,
      })),
    ]}
  />
)}
</div>
    {/* Audit Table */}
    <Table
    loading={isPageLoading}
      columns={auditColumns}
      dataSource={auditTrail}
      // scroll={{ x: "max-content" }} 
      pagination={{
    current: auditPage,
    total: auditTotalPages * auditPageSize, // total items (page count × page size)
    pageSize: auditPageSize,
    showSizeChanger: false,
    onChange: (page) => setAuditPage(page),
    showTotal: (total, range) => `Page ${auditPage} of ${auditTotalPages}`,
    itemRender: (page, type, originalElement) => {
      if (type === "prev") {
        return <Button shape="square" size="large" style={{ border: "none" }}>&lsaquo;</Button>;
      }
      if (type === "next") {
        return <Button shape="square" size="large" style={{ border: "none" }}>&rsaquo;</Button>;
      }
      return originalElement;
    },
  }}
    />
  </>
): (
  // 👉 NEW mapping UI
<>
  {/* Analytics cards */}
  {mappingAnalytics && (
    <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
      <div
        className="mapping-ac mapping-ac-total"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setMappingPage(1);
          setEntityFilter([]);
        }}
      >
        <span className="mapping-ac-value">{mappingAnalytics.total}</span>
        <span className="mapping-ac-label">Total</span>
        <span className="mapping-ac-sub">Mapped customers</span>
      </div>
      {mappingAnalytics.byEntity.map((e) => (
        <div
          key={e.entity}
          className="mapping-ac"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (
              e.entity &&
              (!entityFilter ||
                entityFilter.length !== 1 ||
                entityFilter[0] !== e.entity)
            ) {
              setMappingPage(1);
              setEntityFilter([e.entity]);
            }
          }}
        >
          <span className="mapping-ac-value">{e.count}</span>
          <span className="mapping-ac-label">{e.entity}</span>
          <span className="mapping-ac-sub">Mapped customers</span>
        </div>
      ))}
    </div>
  )}
    {/* Customer filter */}
    <div
  className="mapping-filter-row"
  style={{
    display: "flex",
    gap: 10,
    justifyContent: "space-between",
    marginBottom: 16,
    alignItems: "center",
  }}
>

  {/* Customer Filter */}
  <div className="mapping-customer-filter" style={{width:"600px"}}>
    <EntityMultiSelect
      options={entityOptions.map(e=>e.value).filter(Boolean)}
      selected={entityFilter}
      onChange={(updatedSelected) => {
        setEntityFilter(updatedSelected);
      }}
    />
    <CustomerEntitySelect
  value={filterUI.customer}
  placeholder="Select Customer"
  // width="300px"
  onChange={(val) => {
    // CustomerEntitySelect returns the `value` from options
    // The shared filters use customer id as the UI value and API value.
    if (!val) {
      setFilterUI(prev => ({ ...prev, customer: "" }));
      handleFilter({ customerId: null });
      return;
    }

    const customerId = Number(val);
    // CustomerEntitySelect expects `value` to match its option `value` (stringified).
    // Our options use `value: c.id`, so keep UI value as that id.
    setFilterUI(prev => ({ ...prev, customer: String(customerId || "") }));
    handleFilter({ customerId: customerId || null });
  }}
  options={[
    {
      value: "",
      customerName: "All Customers",
      entityName: "-",
      searchText: "all customer",
    },
    ...customersList.map(c => ({
      value: String(c.id),
      customerName: c.name,
      entityName: c.entity || "-",
      customerCode: c.customerCode || "-",
    })),
  ]}
/>
  </div>

{isAdmin && (
  <Button
    className="price-add-btn"
    type="primary"
    onClick={() => setShowMappingModal(true)}
  >
    <img className="price-map-upload-icon" src={uploadPoIcon} alt="" aria-hidden="true" />
    Map / Unmap Products
  </Button>
)}

</div>

<Modal
  open={showMappingModal}
  onCancel={() => {
    setShowMappingModal(false);
    resetMappingModal();
  }}
  footer={null}
  centered
>
  <Title level={4}>Map / Unmap Products</Title>

  <div style={{ marginTop: 20, display: "flex", flexDirection: "column", gap: 16 }}>

    {/* ✅ 1. Upload Bar (TOP like screenshot) */}
    <div
  onClick={() => fileInputRef.current?.click()}
  style={{
    border: "1px dashed #d9d9d9",
    borderRadius: 8,
    padding: "30px",
    textAlign: "center",
    cursor: "pointer",
    background: pendingFile ? "#f0fdf4" : "#fafafa", // slight green when selected
  }}
>
  {!pendingFile ? (
    <>
      <p style={{ margin: 0, fontWeight: 500 }}>
        Click to upload
      </p>
      <p style={{ margin: 0, fontSize: 12, color: "#888" }}>
        CSV format: Customer Code, Entity, Product Code
      </p>
      <p style={{ margin: 0, fontSize: 12, color: "#888" }}>
        Delimiter: Comma (,) | Max file size: 3MB
      </p>

      <p 
        style={{
          margin: 0,
          fontSize: 12,
          color: "#007bff",
          cursor: "pointer",
          textDecoration: "underline",
        }}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const link = document.createElement("a");
          link.href = "/sample.csv";
          link.download = "sample-template.csv";

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
      >
        Download sample CSV file.
      </p>
    </>
  ) : (
    <>
      <p style={{ margin: 0, fontWeight: 600, color: "#15803D" }}>
        {pendingFile.name}
      </p>
      <p style={{ margin: 0, fontSize: 12, color: "#666" }}>
        Click to change file
      </p>
    </>
  )}
</div>

    <input
      ref={fileInputRef}
      type="file"
      accept=".csv"
      style={{ display: "none" }}
      onChange={(e) => {
  const file = e.target.files[0];
  if (!file) return;

  // ✅ STRICT CSV VALIDATION
  const isCSV =
    file.type === "text/csv" ||
    file.name.toLowerCase().endsWith(".csv");

  if (!isCSV) {
    message.error("Only CSV files are allowed");
    e.target.value = "";
    return;
  }

  setPendingFile(file);
  e.target.value = "";
}}
    />

    {/* {pendingFile && (
      <div style={{ fontSize: 12 }}>
        Selected: {pendingFile.name}
      </div>
    )} */}

    {/* ✅ 2. Dropdown BELOW upload */}
    <CustomSelect
      value={uploadMode}
      onChange={(val) => setUploadMode(val)}
      options={[
        { label: "Map Products", value: "map" },
        { label: "Unmap Products", value: "unmap" },
      ]}
    />

    {/* ✅ 3. Footer buttons (RIGHT SIDE, SAME ROW) */}
    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
      
      <Button
        className="modal-pm-cancel-btn"
        onClick={() => {
          setShowMappingModal(false);
          resetMappingModal();
        }}
      >
        Cancel
      </Button>

      <UploadCSVButton
        file={pendingFile}
        uploadMode={uploadMode}
        apiEndpoint={
          uploadMode === "map"
            ? "/customer/map-products-csv"
            : "/customer/unmap-products-csv"
        }
        onUploadError={() => {
          setPendingFile(null);
        }}
        onSuccess={() => {
          fetchCustomerProductMapping();
          setShowMappingModal(false);
          resetMappingModal();
        }}
      />
    </div>

  </div>
</Modal>


    {/* Table */}
    <div className="price-table-wrapper1">
    <Table
  loading={getPriceTableLoading(mappingLoading)}
  className="price-overview-table"
  columns={mappingColumns}
  dataSource={mappingCustomerRows}
  rowKey={(record) => record.customerId}
  rowClassName={getPriceTableRowClassName}
  expandable={{
    expandedRowRender: renderMappingDesigner,
    expandedRowKeys: expandedMappingCustomerId ? [expandedMappingCustomerId] : [],
    showExpandColumn: false,
    rowExpandable: () => true,
  }}
  onRow={(record) => ({
    onClick: async () => {
      if (String(expandedMappingCustomerId) === String(record.customerId)) {
        clearMappingDraft(record.customerId);
        setMappingSearch(record.customerId, "all", "");
        setMappingSearch(record.customerId, "mapped", "");
        setExpandedMappingCustomerId(null);
        return;
      }

      setExpandedMappingCustomerId(String(record.customerId));
      await fetchMappingProductCategoriesForCustomer(record.customerId);
      await fetchMappingProductsForCustomer(record);
    },
  })}
  pagination={false}
/>
{mappingTotalCount > 0 &&
  renderPaginationControls({
    current: mappingPage,
    totalPages: mappingPaginationTotalPages,
    totalRecords: mappingTotalCount,
    start: mappingPaginationStart,
    end: mappingPaginationEnd,
    onPageChange: setMappingPage,
  })}
    </div>
  </>
)}
      </Card>

      {/* Add / Edit Modal */}
      <Modal
        open={showModal}
        onCancel={() => {
  setShowModal(false);
  setFormData(defaultForm);
  setModalProductList(masterProductList);
  setDateTouched(false);
  setValidationErrors(emptyValidationErrors);
  setDateKey(prev => prev + 1);
}}
        footer={null}
        centered
        width={600}
        className="modal-form"
         maskClosable={false}     //  Prevent closing on outside click
  keyboard={false}   
      >
        <Title level={4}
        style={{
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "20px",
    lineHeight: "100%",
    letterSpacing: "0",
    marginBottom:"6px",
    color: "#7509B8",
  }}>
          {isEdit ? "Edit Customer Discount" : "Add New Customer Discount"}
        </Title>
        <Text type="secondary"
        style={{
    fontFamily: "Poppins",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0",
    color: "#7509B8",
  }}>
          {isEdit
            ? "Update discount information"
            : "Create a new customer-specific discount"}
        </Text>

        <div style={{ marginTop: 20 }}>
          <div className="form-grid">
            {/* Row 1 */}
<div style={{ display: "flex", gap: "10px", }}>
  <div style={{ flex: 1 }} >
  <label style={{
fontWeight:"500",
fontSize:"14px",
lineHeight:"20px",
letterSpacing:"0",
color:"#7509B8",
  }}>Select Customer <span className="required-asterisk">*</span></label>
  <CustomTooltip
  message={
    formData.customer
      ? customersList.find(c => c.id === formData.customer)?.name
      : ""
  }
  show={!!formData.customer}
  color="#4A1476"
>
  <div>
<CustomerEntitySelect
  value={
    formData.customer
      ? customersList.find(c => c.id === formData.customer)?.name
      : ""
  }
  onChange={(name) => {
    const matched = customersList.find(c => c.name === name);
    const customerId = matched?.id || "";
    const currency = matched?.currency || "";

    setFormData({
      customer: customerId,
      customerCurrency: currency,
      productType: "All",
      product: "All",
      validFrom: null,
      validTo: null,
      discountType: "Percentage",
      discountValue: "",
      minimumQuantity: 0,
      notes: "",
    });
    setValidationErrors(emptyValidationErrors);
    setDateTouched(false);
    validateField("customer", customerId);
  }}
  options={customersList.map(c => ({
    value: c.name,
    customerName: c.name || "-",
    entityName: c.entityName || c.entity || c.company || c.organization || c.businessName || "-",
    customerCode: c.customerCode || "-",
    searchText: `${c.name || ""} ${
      c.entityName || c.entity || c.company || c.organization || c.businessName || ""
    } ${c.customerCode||""}`,
  }))}
  placeholder="Select Customer"
  disabled={isEdit}
/>

  </div>
</CustomTooltip>


{validationErrors.customer && (
  <p className="price-error-text">{validationErrors.customer}</p>
)}
</div>


  <div style={{ flex: 1 }} >
  <label style={{
fontWeight:"500",
fontSize:"14px",
lineHeight:"20px",
letterSpacing:"0",
color:"#7509B8"
  }}>Product Type <span className="required-asterisk">*</span></label>
  <CustomSelect
  value={formData.productType}
  onChange={handleProductTypeChange}
   options={["All",]}
  bg="gray"
/>
{validationErrors.productType && (
  <p className="price-error-text">{validationErrors.productType}</p>
)}

</div>

</div>

{/* Row 2 */}
<div style={{ display: "flex", gap: "10px", marginTop: 10 }}>
  <div style={{ flex: 1 }}>
    <label
      style={{
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0",
        color: "#7509B8",
      }}
    >
      {formData.productType === "All"
        ? "Select Product"
        : `Select Product (${formData.productType})`}
      <span className="required-asterisk">*</span>
    </label>

   <ProductCodeSelect
  value={formData.product}
  onChange={(val) => {
    setFormData({ ...formData, product: val });
    validateField("product", val);
  }}
  placeholder="Select Product"
  customerName={selectedCustomerName}
  options={[
    {
      value: "All",
      productCode: "All",
      productDescription: "All Products",
      productType: "",
    },
    ...modalProductList.map((p) => ({
      value: p.code,
      productCode: p.code,
      productDescription: p.description || "",
      productType: formData.productType || "",
    })),
  ]}
/>


    {validationErrors.product && (
      <p className="price-error-text">{validationErrors.product}</p>
    )}
  </div>

  <div style={{ flex: 1 }}>
    <label
      style={{
        fontWeight: "500",
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0",
        color: "#7509B8",
      }}
    >
      Minimum Quantity
    </label>

    <Input
      type="number"
      min={0}
      step={1}
      value={formData.minimumQuantity}
      onChange={(e) => {
        let val = e.target.value.replace(/\D/g, "");
        const num = val === "" ? 0 : Number(val);

        setFormData({
          ...formData,
          minimumQuantity: num,
        });

        if (num > 0) {
          setValidationErrors((prev) => ({
            ...prev,
            minimumQuantity: "",
          }));
        }
      }}
    />

    {validationErrors.minimumQuantity && (
      <p className="price-error-text">
        {validationErrors.minimumQuantity}
      </p>
    )}
  </div>
</div>


            {/* Row 3 */}
            {/* Row 3 - Valid From / Valid To */}
<div style={{ display: "flex", gap: "10px", marginTop: 10 }}>
  <div style={{ flex: 1 }} >
    <label style={{
fontWeight:"500",
fontSize:"14px",
lineHeight:"20px",
letterSpacing:"0",
color:"#7509B8"
  }}>Valid From</label>
  <input
  type="date"
  key={`validFrom-${dateKey}`}
   className="pm-date-input"
  value={formData.validFrom || ""}
  onKeyDown={(e) => e.preventDefault()}
  onChange={(e) => {
    setDateTouched(true);

    const val = e.target.value || "";
    const newForm = { ...formData, validFrom: val };
    setFormData(newForm);

    const errs = validateDatePair(val, newForm.validTo);
    setValidationErrors(prev => ({ ...prev, ...errs }));
  }}
  
/>



{validationErrors.validFrom && (
      <p style={{ color: "#dc2626", fontSize: "12px", marginTop: "4px" }}>
        {validationErrors.validFrom}
      </p>
    )}

  </div>

  <div style={{ flex: 1 }} >
    <label style={{
fontWeight:"500",
fontSize:"14px",
lineHeight:"20px",
letterSpacing:"0",
color:"#7509B8"
  }}>Valid To</label>
  <input
  type="date"
  key={`validTo-${dateKey}`}
   className="pm-date-input"
  value={formData.validTo || ""}
  onKeyDown={(e) => e.preventDefault()}
  onChange={(e) => {
    setDateTouched(true);

    const val = e.target.value || "";
    const newForm = { ...formData, validTo: val };
    setFormData(newForm);

    const errs = validateDatePair(newForm.validFrom, val);
    setValidationErrors(prev => ({
      ...prev,
      ...errs
    }));
  }}  
/>

  {/* <DatePicker
  selected={parseDate(formData.validTo)}
  onChange={(val) => {
    setDateTouched(true);

    const newForm = { ...formData, validTo: val };
    setFormData(newForm);

    const errs = validateDatePair(newForm.validFrom, val);

    setValidationErrors(prev => ({
      ...prev,
      ...errs
    }));
  }}
  dateFormat="dd/MM/yyyy"
  placeholderText="DD/MM/YYYY"
  popperClassName="pm-date-popper1"
  className="pm-dp"
  isClearable
/> */}

{validationErrors.validTo && (
      <p style={{ color: "#dc2626", fontSize: "12px", marginTop: "4px" }}>
        {validationErrors.validTo}
      </p>
    )}
  </div>
</div>

            <div style={{ display: "flex", gap: "10px", marginTop: 10 }}>
              <div style={{ flex: 1 }}>
                <label style={{
fontWeight:"500",
fontSize:"14px",
lineHeight:"20px",
letterSpacing:"0",
color:"#7509B8"
  }}>Discount Type <span className="required-asterisk">*</span></label>
                <CustomSelect
  value={formData.discountType}
  onChange={(v) => {
  setFormData({
    ...formData,
    discountType: v,
    discountValue: ""    //  Clear discount on type change
  });

  // Clear previous validation error
  setValidationErrors((prev) => ({ ...prev, discount: "" }));

  validateField("discountType", v);
}}

  options={["Percentage", "Fixed Price"]}
  style={{backgroundColor:"#F4F4F5"}}
  placeholder="Discount Type"
  bg="gray"
/>
{validationErrors.discountType && (
  <p className="price-error-text">{validationErrors.discountType}</p>
)}

              </div>
              <div style={{ flex: 1 }} className={validationErrors.discount ? "input-error" : ""}>
  <label style={{
fontWeight:"500",
fontSize:"14px",
lineHeight:"20px",
letterSpacing:"0",
color:"#7509B8"
  }}>Discount <span className="required-asterisk">*</span></label>
<Input
  type="text"
  addonBefore={
  formData.discountType === "Fixed Price"
    ? formData.customerCurrency
    : null
}

  value={formData.discountValue || ""}
  onChange={(e) => {
    const val = e.target.value;

    if (!/^\d*\.?\d{0,2}$/.test(val)) return;

    setFormData(prev => ({
      ...prev,
      discountValue: val
    }));

    validateDiscountLive(val);
  }}
/>


  {validationErrors.discount && (
  <p className="price-error-text">{validationErrors.discount}</p>
)}

</div>

            </div>

            {/* Notes */}
            <div style={{ marginTop: 10}} className="ant-input-textarea ant-input-textarea-show-count">
              <label style={{
fontWeight:"500",
fontSize:"14px",
lineHeight:"20px",
letterSpacing:"0",
color:"#7509B8"
  }}>Notes</label>
              <Input.TextArea
                rows={5}
                style={{height:"120px"}}
                placeholder="Add any relevant notes about this discount..."
                value={formData.notes}
                onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              />
            </div>

            {/* Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
                gap: "10px",
                paddingTop:"2em"
              }}
            >
              <Button onClick={() => {
    setShowModal(false);
    setFormData(defaultForm);
    setModalProductList(masterProductList);
    setDateTouched(false);
    setValidationErrors(emptyValidationErrors);
    setDateKey(prev => prev + 1);   // ✅ REQUIRED
  }}
                style={{
    width: "90px",
    height: "44px",
    padding: "10px 16px",
    borderRadius: "8px",
    border: "1px solid #2D0844",
    color: "#2D0844",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
  }}>Cancel</Button>
              <Button
  type="primary"
 style={{
    width: "162px",
    height: "44px",
    padding: "10px 16px",
    borderRadius: "8px",
    border: "1px solid #2D0844",
    color:  "#ffffff",
    backgroundColor: "#2D0844",
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    letterSpacing: "0",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    // Cursor style based on validity
    cursor: !isFormValid() ? "not-allowed" : "pointer",

    // prevents hover styling when disabled
    // pointerEvents: !isFormValid() ? "none" : "auto"
  }}
  onClick={() => setShowSaveConfirm(true)}
  disabled={!isFormValid()}
  className="price-m-btn"
>
 
  {isEdit ? "Update Discount" : "Create Discount"}
</Button>

            </div>
          </div>
        </div>
      </Modal>
      {/* SAVE CONFIRMATION POPUP */}
<ConfirmModal
  open={showSaveConfirm}
  title={isEdit ? "Confirm Update" : "Confirm Save"}
  message={
    isEdit
      ? "Are you sure you want to update this discount?"
      : "Are you sure you want to create this discount?"
  }
  confirmText={isEdit ? "Update" : "Save"}
  cancelText="Cancel"
  confirmType="primary"
  onCancel={() => setShowSaveConfirm(false)}
  onConfirm={async () => {
  setShowSaveConfirm(false);
  const ok = await handleSave();
  console.log("handleSave() returned:", ok);
  if (ok) {
    setShowModal(false);
    // NOW do refetch
    setOverviewProductPage(1);
    if (expandedOverviewCustomerId) {
      fetchDiscounts(1, pageSize, { customerId: expandedOverviewCustomerId });
    }
  }
}}
/>
{/* DELETE CONFIRMATION POPUP */}
<ConfirmModal
  open={showDeleteConfirm}
  title="Confirm Delete"
  message="Are you sure you want to delete this discount?"
  confirmText="Delete"
  cancelText="Cancel"
  confirmType="danger"   // red button
  onCancel={() => setShowDeleteConfirm(false)}
onConfirm={async () => {
  setShowDeleteConfirm(false);

  await handleDelete(deleteId);

  setDeleteId(null);

  // 🔥 Compute next page correctly
  const isLastItemOnPage = discountData.length === 1;
  const nextPage =
    isLastItemOnPage && overviewProductPage > 1 ? overviewProductPage - 1 : overviewProductPage;

  setOverviewProductPage(nextPage);

  if (expandedOverviewCustomerId) {
    fetchDiscounts(nextPage, pageSize, { customerId: expandedOverviewCustomerId });
  }
}}

/>
{alert.message && (
  <div className="alert-overlay">
    <div className={`alert-popup ${alert.type}`}>
      <div className="alert-header">
        <span>{alert.type === "error" ? "Error" : "Warning"}</span>
        <button
          className="alert-close"
          onClick={() =>
            setAlert({ type: "", message: "", navigateOnClose: false })
          }
        >
          ✖
        </button>
      </div>

      <div
        className="alert-body"
        style={{ whiteSpace: "pre-wrap" }}   // 🔥 preserve newlines
      >
        {alert.message}
      </div>

      <div className="alert-footer">
        <button
          className="alert-ok-btn"
          onClick={() => {
            const shouldNavigate = alert.navigateOnClose;

            setAlert({
              type: "",
              message: "",
              navigateOnClose: false,
            });

            if (shouldNavigate) {
              // change if you want a different page
              // navigate("/orders");
            }
          }}
        >
          OK
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
};
 
//merge conflict solved
export default PriceManagement;


